// vim: set ts=2 sw=2 et ft=javascript:
/*
 * Copyright (C) 2011, 2012 Minted Inc.
 *
 * All Rights Reserved
 *
 * CU3 Constants
 */

// TODO: Move all the constants in this file into the M.Cu3 namespace
// to match the convention of a one-to-one mapping between javascript
// namespace and filesystem directory
/*
  UMD header generated via modularize.js at 2015-05-07T00:34:58.079Z
  self-referred dependencies: ONE_COL, TWO_COL
*/
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/underscore-1.8.2.min': '_',
  'minted:constants': []
})(this, function (m_module, _) {

var M = m_module.M;

M.Cu3 = M.Cu3 || {};

M.Cu3.NS = 'http://www.w3.org/2000/svg';

M.Cu3.ENVELOPE_LAYOUT_VERSION = 'v5';

/* constant that indicates a single column
 * shared backer layout */
ONE_COL = 'one-col';

/* constant that indicates a two column
 * shared backer layout */
TWO_COL = 'two-col'

/*
 * Note to developers: You can use this
 * number to determine if the browser picked
 * up your code change.
 */
var DEV_NUM = 122;

// This ratio is used to scale the logo sizes
// The values are derived from the ratio of the width of Preview backer to CU3
// Backer dom elements
var PREVIEW_TO_CU3_BACKER_SIZE_RATIO = {
  CVD: 233.0/431.0,
  CVF: 233.0/431.0,
  SHARED: 338.0/600.0,
  WEDDING: 338.0/600.0,
  RECTANGULAR: 245.0/537.0,
  CIRCULAR: 245.0/537.0
};

// Holds a list with all the tier options that match that type
var Format = {
  FLAT: 0,
  FOLDED: 1,
  MINIBOOK: 2,
  CALENDAR: 3,
  BOOKLETTE: 4,
  DIGITAL_INVITATION: 5,
  STAMP: 6,
  ALL_IN_ONE: 7,
  PERSONALIZED_PILLOW: 8,
  PERSONALIZED_CHAIR: 9,

};

// Holds coordinates of Minted SF office to be the default values of map_data
var DEFAULT_MAP_DATA = {
  'center_coord': {'Lat': 37.7984851, 'Long': -122.4001735},
  'zoom_level': 17
};

// From drupal.minted_tier_options
var Tier = {
  FLAT_CARD:                            1,
  FLAT:                                 12,
  MINIBOOK_A:                           17,
  MINIBOOK_B:                           18,
  FLAT_CARD_W_BACKER:                   22,
  FLAT_CARD_W_ROUND_CORNERS:            23,
  FLAT_CARD_W_ROUND_CORNERS_AND_BACKER: 24,
  MINIBOOK:                             26,
  NOTEBOOK_W_BLANK_PAGES:               45,
  NOTEBOOK_W_LINED_PAGES:               46,
  NOTEBOOK_W_GRAPH_PAPER:               48,
  BOOKLETTE_A:                          67,
  BOOKLETTE_B:                          68,
  BOOKLETTE:                            69,
  DIGITAL_INVITATION:                   76,
  ONE_OUNCE_STAMP:                      88,
  TWO_OUNCE_STAMP:                      89,
  POSTCARD_STAMP:                       90,
  ART_FULL_BLEED:                       92,
  ART_FULL_BLEED_FLOAT:                 121,
  ART_FLOAT:                            93,
  ART_MATTE:                            94,
  ART_WHITE_BORDER:                     95,
  ALL_IN_ONE:                           112,
  PERSONALIZED_PILLOW:                  116,
  PERSONALIZED_CHAIR:                   117,
};

// product formats -- these are IDs in the minted_tier_option table
// TODO: Replace references to the following variables with those in
// M.FormatOptions.
var FLAT_FORMAT = 1;
var FOLDED_BLANK_FORMAT = 2;
var FOLDED_YEARLINE_FORMAT = 3;
var FOLDED_LETTER_FORMAT = 4;
var FOLDED_MESSAGE_FORMAT = 16;
var CALENDAR = 39;
var LINED_NOTEBOOK_FORMAT = 46;
var GRAPH_NOTEBOOK_FORMAT = 48;
var BOOKLETTE_A_FORMAT = 67;
var BOOKLETTE_B_FORMAT = 68;
var BOOKLETTE_FORMAT = 69;
var DIGITAL_INVITATION_FORMAT = Tier.DIGITAL_INVITATION;

var FORMAT_TIER_MAP = {};
FORMAT_TIER_MAP[Format.FLAT] = [
  Tier.FLAT_CARD,
  Tier.FLAT,
  Tier.FLAT_CARD_W_BACKER,
  Tier.ART_FULL_BLEED,
  Tier.ART_FULL_BLEED_FLOAT,
  Tier.ART_FLOAT,
  Tier.ART_MATTE,
  Tier.ART_WHITE_BORDER,
  M.FormatOptions.BLANK_NOTEBOOK,
  M.FormatOptions.LINED_NOTEBOOK,
  M.FormatOptions.GRAPH_NOTEBOOK,
  M.FormatOptions.WEEKLY_PLANNER_NOTEBOOK,
  M.FormatOptions.MONTHLY_PLANNER_NOTEBOOK,
  M.FormatOptions.ADDRESS_BOOK_NOTEBOOK,
  M.FormatOptions.GRID_NOTEBOOK,
  M.FormatOptions.DAILY_NOTEBOOK,
  M.FormatOptions.WEEKLY_NOTEBOOK,
];
FORMAT_TIER_MAP[Format.MINIBOOK] = [
  Tier.MINIBOOK_A,
  Tier.MINIBOOK_B,
  Tier.MINIBOOK];
FORMAT_TIER_MAP[Format.FOLDED] = [
  FOLDED_BLANK_FORMAT,
  FOLDED_YEARLINE_FORMAT,
  FOLDED_LETTER_FORMAT,
  FOLDED_MESSAGE_FORMAT];
FORMAT_TIER_MAP[Format.BOOKLETTE] = [
  Tier.BOOKLETTE_A,
  Tier.BOOKLETTE_B,
  Tier.BOOKLETTE];

FORMAT_TIER_MAP[Format.DIGITAL_INVITATION] = [
  M.FormatOptions.DIGITAL_INVITATION
];

FORMAT_TIER_MAP[Format.STAMP] = [
  Tier.ONE_OUNCE_STAMP,
  Tier.TWO_OUNCE_STAMP,
  Tier.POSTCARD_STAMP];

FORMAT_TIER_MAP[Format.ALL_IN_ONE] = [
  M.FormatOptions.ALL_IN_ONE
];

FORMAT_TIER_MAP[Format.PERSONALIZED_PILLOW] = [
  Tier.PERSONALIZED_PILLOW
];

FORMAT_TIER_MAP[Format.PERSONALIZED_CHAIR] = [
  Tier.PERSONALIZED_CHAIR
];

M.FOLDED_FORMATS = [
  FOLDED_BLANK_FORMAT,
  FOLDED_YEARLINE_FORMAT,
  FOLDED_LETTER_FORMAT,
  FOLDED_MESSAGE_FORMAT]

// format id to css class map
var FORMAT_TO_CSS_CLASS_MAP = {};
FORMAT_TO_CSS_CLASS_MAP[FLAT_FORMAT] = 'flatFormat';
FORMAT_TO_CSS_CLASS_MAP[FOLDED_BLANK_FORMAT] = 'foldedBlankFormat';
FORMAT_TO_CSS_CLASS_MAP[FOLDED_YEARLINE_FORMAT] = 'yearlineFormat';
FORMAT_TO_CSS_CLASS_MAP[FOLDED_LETTER_FORMAT] = 'foldedLetterFormat';
FORMAT_TO_CSS_CLASS_MAP[FOLDED_MESSAGE_FORMAT] = 'foldedMessageFormat';

// paper options
var SIGNATURE = 5;
var RECYCLED_PAPER = 20;
var PEARLESCENT = 7;
var STRATHMORE = 11;
var CALENDAR_PAPER = 40;
var PREMIUM_UNCOATED = 47;
var TRIPLE_THICK = 50;
var PARTY = 51;
var MUSEUM_BOARD = 53;
var MAGNET = 55;
var SOMERSET_500 = 56;
var COVENTRY_320 = 57;
var POLY = 59;
var CANVAS = 60;
var DOUBLE_THICK = 61;
var DELUXE_ART = 62;
var SIGNATURE_80 = 70;
var UNCOATED_STICKER = 77;
var WATERPROOF_LABEL = 78;
var SAVOY_BRIGHT_WHITE = 79;
var ADHESIVE_POSTAGE_PAPER = 87;
var VELLUM = 91;
var SMOOTH_SIGNATURE = 107;
var SIGNATURETEXT_100 = 111;
var PREMIUM_MATTE_ADHESIVE_FABRIC = 113;
var VALUE_COVER = 114;
var RECYCLED_SMOOTH_SIGNATURE = 120;
var RECYCLED_100 = 122;

var RECYCLED_PAPERS = [
  RECYCLED_PAPER,
  TRIPLE_THICK,
  DOUBLE_THICK,
  RECYCLED_SMOOTH_SIGNATURE
];

// Keep this list in sync with THICK_PAPER_KINDS in
// src/py/minted/model/constants.py
var THICK_PAPER_KINDS = [DOUBLE_THICK, TRIPLE_THICK, MUSEUM_BOARD];
var TRIPLE_THICK_PAPER_KINDS = [TRIPLE_THICK, MUSEUM_BOARD];

var PAPER_OPTION_LABELS = {};
PAPER_OPTION_LABELS[SIGNATURE] = 'Signature';
PAPER_OPTION_LABELS[RECYCLED_PAPER] = 'Recycled';
PAPER_OPTION_LABELS[PEARLESCENT] = 'Pearlescent';
PAPER_OPTION_LABELS[STRATHMORE] = 'Signature Cover Paper';
PAPER_OPTION_LABELS[PREMIUM_UNCOATED] = 'Premium Cover Stock';
PAPER_OPTION_LABELS[TRIPLE_THICK] = 'TripleThick&trade;';
PAPER_OPTION_LABELS[MUSEUM_BOARD] = 'Luxe Museum Board';
PAPER_OPTION_LABELS[PARTY] = 'Double Thick Photo Mount';
PAPER_OPTION_LABELS[MAGNET] = 'Magnet';
PAPER_OPTION_LABELS[SOMERSET_500] = 'Premium 100% Cotton';
PAPER_OPTION_LABELS[COVENTRY_320] = '100% Cotton';
PAPER_OPTION_LABELS[POLY] = 'Poly';
PAPER_OPTION_LABELS[CANVAS] = 'Canvas';
PAPER_OPTION_LABELS[DOUBLE_THICK] = 'DoubleThick';
PAPER_OPTION_LABELS[DELUXE_ART] = 'Standard Art';
PAPER_OPTION_LABELS[SIGNATURE_80] = 'Signature 80 lb.';
PAPER_OPTION_LABELS[UNCOATED_STICKER] = 'Uncoated Sticker Paper';
PAPER_OPTION_LABELS[WATERPROOF_LABEL] = 'Waterproof Sticker Paper';
PAPER_OPTION_LABELS[SAVOY_BRIGHT_WHITE] = 'Luxury Cotton Paper';
PAPER_OPTION_LABELS[VELLUM] = 'Translucent Vellum';
PAPER_OPTION_LABELS[SMOOTH_SIGNATURE] = 'Smooth Signature';
PAPER_OPTION_LABELS[SIGNATURETEXT_100] = 'Signature Text';
PAPER_OPTION_LABELS[PREMIUM_MATTE_ADHESIVE_FABRIC] = 'Premium Matte Self-Adhesive Material';
PAPER_OPTION_LABELS[VALUE_COVER] = 'Value Cover';
PAPER_OPTION_LABELS[RECYCLED_SMOOTH_SIGNATURE] = 'Smooth Signature';
PAPER_OPTION_LABELS[RECYCLED_100] = 'Recycled Text';

// Enable/disable features
// TODO: Remove some of these as they have become stable or depercated
var ENABLE_ROTATED_TEXT = true;
var ENABLE_MOVEABLE_TEXT = true;
var ENABLE_MOVEABLE_IMAGE = true;
var ENABLE_BACKER_ALT_COLORS = true;
var ENABLE_SKINNYWRAP_COLORS = true;
var ENABLE_SKINNYWRAP_GREETINGS = true;
var ENABLE_CUSTOM_COLORS = true;
var ENABLE_DRAG_DROP_PHOTO_UPLOAD = true;
var ENABLE_SCENE7_OVERSET = true;
var ENABLE_ROTATE_IMAGE = false;
var ENABLE_PHOTO_DRAG_AND_DROP = true;

var SKIP_REPLICA = false;
var IMAGE_OVERLAY_DRAG_CONTAINTMENT = 'false';
/* valid values for IMAGE_OVERLAY_DRAG_CONTAINTMENT:
  parent - contain the overlay movement in the parent element
  false - do not restrict overlay movement
*/
// Events
var COLORWAY_CHANGED_EVENT = 'COLORWAY_CHANGED_EVENT';
var FIRST_RENDER_EVENT     = 'FIRST_RENDER_EVENT';

/* Constants */
var GAQ_CATEGORY = 'cu3_nf'; // 'nf' for noise filtered
var MOUSEOVER_COLOR = "#8AAD3A";
var DEFAULT_COLOR = "#333";
var MINTED_CDN = "https://mintedcdn.s3.amazonaws.com/";
var AMAZON_S3_ENDPOINT = MINTED_CDN + 'files/mintedProductsImages/';
var THUMBNAIL_INDEX_COLORWAY = "007";
var THUMBNAIL_INDEX_VIEWCODE = "007B";
var LARGE_PHOTO_CODE = "PZ";
var THUMBNAIL_TYPE_COLORWAY = "CP";
var LARGE_THUMBNAIL_TYPE_COLORWAY = "EP";
var DEFAULT_COLORWAY_CODE = "A";
var THUMBNAIL_INDEX_BACKER = "BKR";
var THUMBNAIL_TYPE_BACKER = "CS";
var ID_UNITPRICE = "unitprice";
var ID_TOTALPRICE = "totalprice";
var PHOTO_GREY_MASK_S3KEY = "defaultpng";
var PHOTO_WHITE_MASK_S3KEY = "defaultwhitepng";
var TEMPLATE_MAX_WIDTH = 600;
var TEMPLATE_BUSINESS_MAX_WIDTH = 490;
var TEMPLATE_INSIDE_MAX_WIDTH = 940;
var IMAGE_DRAGBOX_SIZE = [300, 300];
var TEMPLATE_ENVELOPE_CONTAINER_SIZE = [550, 763];
var SKINNYWRAP_IMAGEBOX_SIZE = [300, 300];
var DEFAULT_SWATCH_SIZE = [112, 72];
var MAX_SWATCH_SIZE = DEFAULT_SWATCH_SIZE[0];
var CALENDAR_MONTH_IMG_GROUP_KEY = 'img1';
var CALENDAR_YEAR_IMG_GROUP_KEY = 'img2';
var INSIDE_TEMPLATE_HEIGHT_CONSTRAINT = 108;
var ONE_PAGE_CALENDAR_ZOOM_COEFFICIENT = 1.6;
var ONE_PAGE_CALENDAR_USER_ZOOM_COEFFICIENT = 2.4;

/* Photo dialog */
// TODO: Move these constants to the M.PhotoDialog namespace
M.PhotoDialog = M.PhotoDialog || {};
var SWFUPLOAD_BUTTON_SIZE = [140, 38];
var PHOTOTRAY_ICON_WIDTH = 92;
var VALID_UPLOAD_TYPES = "*.png; *.PNG; *.jpeg; *.JPEG; *.jpg; *.JPG; *.gif; *.GIF; *.svg; *.SVG; *.eps; *.EPS";
var SCREEN_DPI = 72;
var WARNING_DPI = 180;
var LOWEST_DPI = 100;
var OUTZOOM_MAX = 1;
var MARGIN_OF_ERROR = 0.02; // Allowed margin of error for floating point arithmetics
var ZOOM_AMOUNT = 0.10;
M.PhotoDialog.UNZOOMED_LEVEL = 1;
M.PhotoDialog.MAX_ZOOM = 3;
var MAX_ZOOMS_BEFORE_PIXELATION = 2;

var MINIMUM_DELAY_FOR_AJAX_SEND = 100;

// Depending on the aspect ratio, an image will appear blurry at certain widths
// This hack maps a width to a different width, where the new width will result
// in a crisper image
var BLUR_FIX_WIDTH_MAP = {
  460: 461,
  430: 431,
  490: 492,
  431: 432
};

var LINER_TYPE_SQ5_GOLD = 31665;
var LINER_TYPE_SQ5_SILV = 31667;
var LINER_TYPE_SQ5_GLIT = 31669;
var LINER_TYPE_SQ6_GOLD = 31671;
var LINER_TYPE_SQ6_SILV = 31673;
var LINER_TYPE_SQ6_GLIT = 31675;
var LINER_TYPE_A7_GOLD = 31677;
var LINER_TYPE_A7_SILV = 31679;
var LINER_TYPE_A7_GLIT = 31681;


var PROOF_SERVICE_EXPRESS = "express";
var PROOF_SERVICE_FULL = "regular";

var ITEM_TYPE_MAIN = "MAIN";
var ITEM_TYPE_RAP  = "RAP";
var ITEM_TYPE_SKINNYWRAP = "SKINNYWRAP";

var TYPE_OPTIONS = "options";
var TYPE_FRONT = "base";
var TYPE_BACK = "backer";
var TYPE_INSIDE = "inside";
var TYPE_BOOKLETTE_INSIDE = "booklette_inside";
var TYPE_ENVELOPE = "envelope";
var TYPE_SKINNYWRAP = 'skinnywrap';
var TYPE_NAMES = 'names';
var TYPE_ADDRESSES = 'addresses';
var TYPE_STAMPS = 'stamps';
var TYPE_DI_FRONT = 'di_front';
var TYPE_DI_BACKGROUND = 'di_background';
var TYPE_DI_DETAILS = 'di_details';
var TYPE_DI_DELIVERY = 'di_delivery';
var DI_BACKGROUND_TAB = 'diBackground';
var DI_DETAILS_TAB = 'diDetails';
var TYPE_PREVIEW = 'preview';

var FRAME_IDS = [
  TYPE_OPTIONS,
  TYPE_FRONT,
  TYPE_BACK,
  TYPE_INSIDE,
  TYPE_BOOKLETTE_INSIDE,
  TYPE_ENVELOPE,
  TYPE_STAMPS,
  TYPE_SKINNYWRAP,
  TYPE_NAMES,
  TYPE_ADDRESSES,
  TYPE_DI_FRONT,
  TYPE_DI_BACKGROUND,
  TYPE_DI_DETAILS,
  TYPE_DI_DELIVERY
];

var TEMPLATE_DATA_TYPE_FRONT = "FRONT";
var TEMPLATE_DATA_TYPE_BACKER = "BACKER";
var TEMPLATE_DATA_TYPE_ENVELOPE = "ENVELOPE";
var FORMAT_YEARLINE = 3;
var VALID_COLOR_TAB_TYPES = [TYPE_FRONT, TYPE_BACK, TYPE_INSIDE];
var CROP_SAVE = 0;
var CROP_LOAD = 1;
var CROP_NORMAL = 3;
var TEXTBOX_ADJUSTMENT = 4; // Hack: adjust the offset of the textbox by this much to account for different font baselines
var BLEED_LENGTH = 7.2;
var BLEED_MASK = 20; // Controls the amount of bleed cut off on the customizer preview.  In case of widespread issues, revert back to 8
var EMBED_BLEED = 8;

var CUSTOM_COLORS_INSTRUCTIONS_DEFAULT_TEXT =
'In addition to picking swatches or creating your own, you can leave us more ' +
'detailed instructions.\n\nYou can:\n\n- Reference a color in a different ' +
'design on Minted\n\n- Reference a color on another website (please provide a ' +
'URL)\n\n- Provide a Pantone number\n\n- Provide CMYK values';
var CUSTOM_COLORS_FIRST_LAUNCH_DEFAULT_TEXT =
'<p class="caption"><b>This palette picker won\'t update your preview</b>, ' +
'but will help our professional Design Associates get a better idea of what ' +
'you\'re looking for. One of our Design Associates will email a digital proof ' +
'reflecting your desired color scheme.</p><p class="caption">Please note that ' +
'the colors on your screen cannot be considered representative of the way the ' +
'colors will print due to differences across monitors.</p>';
var CUSTOM_COLORS_CUSTOMIZATION_DEFAULT_TEXT =
'How would you like to use this color?';
var DESIGN_REQUESTS_DEFAULT_TEXT =
'Please describe any design changes you would like. After you place your order, ' +
'one of our professional Design Associates will make the changes and email you ' +
'a proof for your review.';
var DESIGN_REQUESTS_DEFAULT_TEXT_NO_PROOF =
'Click the "design requests" link to describe additional design tweaks you ' +
'would like, and one of our professional Design Associates will be happy to ' +
'help you. Large customization requests will incur an additional design fee of ' +
'$25. A Design Associate will be in touch with you soon after placing your ' +
'order to discuss any potential fees.';
var STATIC_ELEMENTS_DEFAULT_TEXT =
'Describe additional tweaks you need and one of our professional Design ' +
'Associates will be happy to help you.  Type in your requests here.';

// Keep in sync with list below
var CARDSIZES = {
  A7: '5,7',
  '6X8': '5.75,8.04',
  49: '4,9.375',
  A2: '4.25,5.5',
  LC: '3.5,4',
  Q15x15: '1.5,1.5',
  Q25x25: '2.5,2.5',
  Q5: '5.25,5.25',
  Q6: '6,6',
  BC: '2,3.5', //Also used for stickers
  QB: '2.25,2.25', //Also used for stickers
  TC: '2.5,3.5',
  Q3: '3,3',
  PDY: '4,11.5',
  MC: '4.25,6',
  REC225x75: '0.75,2.25',
  REC225x125: '1.25,2.25',
  REC275x175: '1.75,2.75',
  REC3x15: '1.5,3',
  REC38x6: '0.6,3.8',
  REC4x15: '1.5,4',
  AIO: '5.76,12.03',
  S1: '2.5,7',
  S2: '8,10',
  S3: '11,14',
  S4: '16,20',
  S5: '18,24',
  HD21x12: '21,12', // PPP
  HDSQ18: '18,18',
  HDSQ20: '20,20',
  HDSQ24: '24,24',
  HDSQ40: '40,40',
  HD21x20: '21,20', // PTR
};

// keep in sync with DIM_TO_CARDSIZES in src/py/minted/model/constants.py
// used for getting card size and construct fxg file name
var DIM_TO_CARDSIZES = {
  '5,7': 'A7',
  '5.2,7.2': 'A7',
  '5.25,7.25': 'A7', // envelopes
  '4,9.375': '49',
  '4.25,5.5': 'A2',
  '4.375,5.75': 'A2', // envelopes
  '3.5,4': 'LC',
  '1.5,1.5': 'Q15x15',
  '2.5,2.5': 'Q25x25',
  '3,3': 'Q3',
  '5.25,5.25': 'Q5',
  '5.5,5.5': 'Q5', // envelopes
  '6,6': 'Q6',
  '6.25,6.25': 'Q6', // envelopes
  '2,3.5': 'BC', //Also used for stickers
  '2.25,2.25': 'QB', //Also used for stickers
  '2.5,3.5': 'TC',
  '4,11.5': 'PDY',
  '4.25,6': 'MC',
  '4.45,6.2': 'MC',
  '4.5,6.25': 'MC', // envelopes
  '8.5,11.5': 'DS',
  '0.75,2.25': 'REC225x75',
  '1.25,2.25': 'REC225x125',
  '1.75,2.75': 'REC275x175',
  '1.5,3': 'REC3x15',
  '0.6,3.8': 'REC38x6',
  '1.5,4': 'REC4x15',
  '0.375,0.8125': 'REC8125x375',
  '5.76,12.03': 'AO',
  '2.5,7': 'S1',
  '8,10': 'S2',
  '11,14': 'S3',
  '16,20': 'S4',
  '18,24': 'S5',
  '5.75,8.04': '6X8',
  '5.95,8.24': '6X8', // envelopes
  '6,8': '6X8',
  '6.01,8.30': '6X8',
  '8,6': '6X8',
  '21,12' : 'HD21x12', // PPP
  '20.8,11.8': 'HD21x12',
  '18,18' : 'HDSQ18',
  '17.8,17.8': 'HDSQ18',
  '20,20' : 'HDSQ20',
  '19.8,19.8' : 'HDSQ20',
  '24,24' : 'HDSQ24',
  '23.8,23.8' : 'HDSQ24',
  '40,40' : 'HDSQ40',
  '39.8,39.8' : 'HDSQ40',
  '21,20' : 'HD21x20', // PTR
  '20.8,19.8' : 'HD21x20',
  '19.8,20.8' : 'HD21x20',
};


// Calendar Dimensions
var CALENDAR_STANDARD_DIMENSIONS = {
  width: 8,
  height: 11.5
};
var CALENDAR_GRAND_DIMENSIONS = {
  width: 11.5,
  height: 14
};

var CALENDAR_COLUMNS = 7; // 7 days in a week
var CALENDAR_ROWS = 5; // 5 weeks represented in a month template

var CALENDAR_CELLS = CALENDAR_COLUMNS * CALENDAR_ROWS; // 35

var CALENDAR_TEXT_CELLS_IDS_MAX = CALENDAR_CELLS * 2; // 70
var CALENDAR_TEXT_CELLS_IDS_MIN = CALENDAR_CELLS + 1; // 36

// NOTE: These appear to correspond to the constants in
// minted.model.constants.FormFactor -- keep the two lists in
// sync with each other
var FORM_FACTOR_LANDSCAPE = 0;
var FORM_FACTOR_PORTRAIT = 1;
var FORM_FACTOR_SQUARE = 2;

var ORIENTATION_LETTERS = {};
ORIENTATION_LETTERS[FORM_FACTOR_LANDSCAPE] = 'L';
ORIENTATION_LETTERS[FORM_FACTOR_PORTRAIT] = 'P';
ORIENTATION_LETTERS[FORM_FACTOR_SQUARE] = 'S';

var SKINNYWRAP_RENDER_SCALE = {
  '5,7':       0.692,
  '5.25,5.25': 0.675,
  '4,9.375':   0.587,
  '4.25,5.5':  0.587
};

var MAX_ODD_FONT_SIZE = 11; // Keep this constant in sync with MAX_ODD_FONT_SIZE in ProductModel.class.php
var MIN_DESIGN_ELEMENT_SIZE = 12;
var DUPLICATE_FONT_COLOR_THRESHOLD = 12.75; // 5 * 255 / 100

var NUDGE_AMOUNT = 1; // in pixels
var NUDGE_UP = 'up';
var NUDGE_RIGHT = 'right';
var NUDGE_DOWN = 'down';
var NUDGE_LEFT = 'left';

var PRICING_FREE_BIZ_CARDS = 'FREE BUSINESS CARDS';

// TODO: Use the database to generate a file with all of these constants
// the would come from the product_kind_attribute table. Keeping these values
// in sync with the database requires work.

// Product kinds that do not enable liners.
//TODO: Remove hardcoding and replace with data-driven attributes.
var NO_LINER = [ 'KST', 'PST', 'BST', 'TYC', 'MVA', 'SMG', 'BMG'];

// Keep in sync with ProductSkuInfo.class.php $LOW_ATV_NO_PROOF
var LOW_ATV_NO_PROOF = ['BSC', 'BST', 'GFT', 'KSH', 'KST', 'LIN', 'PSH', 'PST'];

var ART_CU3_W_PROOF =  ['FCA', 'WCA', 'BCA'];
var ART_CU3_NO_PROOF = ['KCA', 'NCA', 'GCA', 'FMA', 'KCP', 'GCP', 'NCP'];
var ART_WEB_TO_PRINT = ['KNA', 'NNA', 'GNA', 'NPA', 'KPA', 'GPA', 'WNA'];

// LATEST NOTE: It looks like almost all of these have been updated to use
// the newest backer/interior setup and therefore we don't need this constant
// for much longer. Once this is no longer needed, remove related code that
// leverages these constants.
// TODO: Invert the list and rename to ALTERNATE_BACKERS_KINDS_DISABLED.
// It should consist only of INV.
// TODO: Take note that if you add a new product kind, then you must create
// a complementary migration similar to migration_338.sql.
var ALTERNATE_BACKER_PRODUCT_TYPES = ['EAS'];
var ALTERNATE_INTERIOR_PRODUCT_TYPES = ALTERNATE_BACKER_PRODUCT_TYPES;


// It looks like the authoritative list of interior types for
// "newer"-style interiors ZZn (where n > 1), e.g. ZZ2, ZZ3, ZZ4, ...
// is stored in javascript in
// drupal/static/src/js/cu3/color_choice_inside_list_factory.js
// Greeting cards have exactly two backers, ZZ7 and ZZ8 which are not
// currently used by any other product kind
// NOTE: Keep this in sync with minted.model.product_kind.
// GREETING_CARD_PRODUCT_KINDS -- keep the two lists in sync
M.Cu3.GREETING_CARD_INTERIOR_PRODUCT_TYPES = [
  'GEA', 'GFD', 'GGR', 'GJB', 'GMD', 'GRA', 'GRT', 'GRU', 'GRY', 'GVD',
  'GRC', 'GRK', 'IFG', 'IFF', 'IBG', 'IKG', 'IWG', 'IAG', 'IBC', 'IJG',
  'ISG', 'IGW', 'ITG', 'ICG', 'IMG', 'IFD', 'IVD', 'IGG', 'IBL', 'IHG',
  'IFA'
];

M.Cu3.ON_DEMAND_GREETING_CARDS = [
  'IFG', 'IFF', 'IBG', 'IKG', 'IWG', 'IAG', 'IBC', 'IJG', 'ISG', 'IGW',
  'ITG', 'ICG', 'IMG', 'IFD', 'IVD', 'IGG', 'IBL', 'IHG', 'IFA'
];

// Party product kinds
M.Cu3.PARTY_NO_PROOF_PRODUCT_TYPES = ['PGS', 'PG2', 'PTS', 'PT2', 'PBD', 'PRN'];
M.Cu3.PARTY_NO_ENVELOPE_PRODUCT_TYPES = ['PGS', 'PG2', 'PTS', 'PT2', 'PBD', 'PRN'];
M.Cu3.PARTY_NO_BACK_TAB_PRODUCT_TYPES = ['PTS', 'PT2', 'PBD', 'PRN'];
M.Cu3.PARTY_NO_BACKER_PRODUCT_TYPES = ['PGS', 'PG2', 'PBD', 'PRN'];
// Large product kinds that are zoomed by default
M.Cu3.PARTY_DEFAULT_ZOOM_TYPES = ['PBD', 'PRN'];
M.Cu3.BUNDLE_PRODUCT_TYPES = ['BDL', 'BD2', 'BD3'];
M.Cu3.HOLIDAY_PRODUCT_KINDS = ['BCC', 'BFC', 'CHR', 'CWR', 'FBM', 'FBP', 'FHB',
  'FPC', 'FPI', 'HBK', 'HBM', 'HCP', 'HFC', 'HFM', 'HFO', 'HFS', 'HLE', 'HMB',
  'HMC', 'HNP', 'HNY', 'HOC', 'HPA', 'HPC', 'HSM', 'HYC'];

// Magnet product kinds
M.Cu3.MAGNET_PRODUCT_KINDS = ['SMG', 'BMG', 'SMF', 'GMG', 'GMF', 'BMF'];

// Booklette product kinds
M.Cu3.BOOKLETTE_PRODUCT_KINDS = ['HBK', 'GBK', 'BYK', 'WBK'];

// EC-14311 - We need to make a single standalone envelope (pk EGN) to look and
// perform like a letterpress LPI envelope.
M.Cu3.EURO_FLAP_STANDALONE_ENVELOPE_SKUS = ['MIN-PB9-EGN', 'MIN-PA2-EGN', 'MIN-PA3-EGN'];

// Letterpress Art product kinds
M.Cu3.LETTERPRESS_ART_PRODUCT_KINDS = ['DLA', 'HLA', 'MLA', 'SLA'];

// Luxury Art product kinds
M.Cu3.LUXURY_ART_PRODUCT_KINDS = ['DDA', 'MFA', 'MLA', 'SDA', 'HDA', 'MDA',
  'SFA', 'HLA', 'DFA', 'SLA', 'DLA'];

M.Cu3.LUXURY_PRODUCT_TYPES = {
  HOUSE: 'house',
  DRAWING: 'drawing',
  MAP: 'map',
  SILHOUETTE: 'silhouette'
}

// Map product kinds
M.Cu3.MAP_PRODUCT_KINDS = ['MFA', 'MDA', 'MLA'];

// Silhouette Art product kinds
M.Cu3.SILHOUETTE_ART_PRODUCT_KINDS = ['SDA', 'SFA', 'SLA'];

// House Art product kinds
M.Cu3.HOUSE_ART_PRODUCT_KINDS = ['HDA', 'HLA'];

M.Cu3.BUY_NOW_PERSONALIZE_LATER_KINDS = ['BYA', 'BTY'];

// Product kinds that are eligible for party product upsell
M.Cu3.PARTY_UPSELL_KINDS = ['BSH', 'BSI', 'CBP', 'HPA', 'PAR'];

// Product kinds to use smooth loading style
M.Cu3.SMOOTH_LOADING_PRODUCT_KINDS = ['GCP', 'GCA', 'WCA', 'FCA', 'KCP', 'NCP'];
M.Cu3.AB_TEST_SMOOTH_LOADING_PRODUCT_KINDS = ['BYA', 'INV', 'STD'];

// Marketplace selflaunch product kinds
M.Cu3.MARKETPLACE_SELFLAUNCH_PRODUCT_KINDS = ['MPS'];

// Skinnywrap PKs
M.Cu3.SKINNYWRAP_PRODUCT_KINDS = ['KLB', 'KLP', 'SKL'];

var NO_INSIDE_TAB = ['CVD', 'CVF', 'TYC', 'BTY', 'LTY', 'GTY', 'CTY',
  'PDY', 'PLC', 'CST', 'CNL', 'TBL', 'TBF'];

// Product actually has no backer.
var NO_BACKER = ['BCA', 'FCA', 'FMA', 'GCA', 'GCP', 'GNA', 'GPA',
  'KCA', 'KCP', 'KNA', 'KPA', 'NCA', 'NCP', 'NNA', 'NPA', 'WCA',
  'BTY', 'CTY', 'DTY', 'FTY', 'GTY', 'HTY', 'MTY', 'PTY', 'WTY', 'CST',
  'CNL' , 'YNV', 'YRS'].concat(M.Cu3.PARTY_NO_BACKER_PRODUCT_TYPES);
// Product just doesn't show the back tab. For now at least, NO_BACKER is
// a subset of NO_BACK_TAB.
var NO_BACK_TAB = NO_BACKER.concat(M.Cu3.PARTY_NO_BACK_TAB_PRODUCT_TYPES);
var ENABLE_ALTERNATE_GREETINGS = false;

M.Cu3.DIE_CUT = M.DIECUT.SHAPE;

// We use diecut ID to map the relationship of unpunched to punched shapes
// the reason is the templateOptionList stores the dieCutID
M.Cu3.UNPUNCHED_DIE_CUT_ID_TO_PUNCHED = {};
M.Cu3.PUNCHED_DIE_CUT_ID_TO_UNPUNCHED = {};

for(var key in M.DIECUT.UNPUNCHED_TO_PUNCHED_SHAPE) {
  M.Cu3.UNPUNCHED_DIE_CUT_ID_TO_PUNCHED[M.DIECUT.SHAPE[key]] = M.DIECUT.SHAPE[M.DIECUT.UNPUNCHED_TO_PUNCHED_SHAPE[key]];
}

for(key in M.DIECUT.PUNCHED_TO_UNPUNCHED_SHAPE) {
  if(typeof M.DIECUT.SHAPE[M.DIECUT.PUNCHED_TO_UNPUNCHED_SHAPE[key]] !== 'undefined') {
    M.Cu3.PUNCHED_DIE_CUT_ID_TO_UNPUNCHED[M.DIECUT.SHAPE[key]] = M.DIECUT.SHAPE[M.DIECUT.PUNCHED_TO_UNPUNCHED_SHAPE[key]];
  }
  else{
    M.Cu3.PUNCHED_DIE_CUT_ID_TO_UNPUNCHED[M.DIECUT.SHAPE[key]] =  null;
  }
}


M.Cu3.DIMENSION_TO_DEFAULT_HOLE_PUNCH_DIE_CUT = {
  // '2.5,7' is the dimension of the diecut, 2.5 is width and 7 is height
  // ['2.5,7'] and ['7,2.5'] are the same diecut; one is portrait and the other is
  // landscape
  '2.5,7': 97,
  '7,2.5': 97,
  '5,7': 98,
  '7,5': 98,
  '8,10': 99,
  '10,8': 99,
  '11,14': 100,
  '14,11': 100
};

// The list of shapes that do not use die-cut logo asset
// keep in sync with NON_DIE_CUT_LOGO_LIST in model/constants.py
M.Cu3.DIE_CUT.NON_DIE_CUT_LOGO_LIST = [
  // square rounded corners
  M.Cu3.DIE_CUT['rounded-corners-a7'],
  M.Cu3.DIE_CUT['rounded-corners-sq5'],
  M.Cu3.DIE_CUT['rounded-corners-a2'],
  M.Cu3.DIE_CUT['rounded-corners-sq6'],
  M.Cu3.DIE_CUT['rounded-corners-6x425'],

  // classic frame
  M.Cu3.DIE_CUT['classic-frame-a7'],
  M.Cu3.DIE_CUT['classic-frame-a2'],

  // tag
  M.Cu3.DIE_CUT['tag-a7'],

  // arch
  M.Cu3.DIE_CUT['arch-a7'],
  M.Cu3.DIE_CUT['arch-a2'],

  // curved edge
  M.Cu3.DIE_CUT['curved-edge-a7']
];

// An offset in pixels. How far should the logo be positioned from the
// bottom of the backer rendering.
M.Cu3.DIE_CUT.DEFAULT_WEDDING_BACKER_LOGO_Y_POSITION = 110;
M.Cu3.DIE_CUT.WEDDING_BACKER_LOGO_Y_POSITIONS = {};
M.Cu3.DIE_CUT.WEDDING_BACKER_LOGO_Y_POSITIONS[M.Cu3.DIE_CUT['bubble-scallop-a7']] = 118;
M.Cu3.DIE_CUT.WEDDING_BACKER_LOGO_Y_POSITIONS[M.Cu3.DIE_CUT['dotted-scallop-a7']] = 132;
M.Cu3.DIE_CUT.WEDDING_BACKER_LOGO_Y_POSITIONS[M.Cu3.DIE_CUT['classic-frame-a7']] = 120;
M.Cu3.DIE_CUT.WEDDING_BACKER_LOGO_Y_POSITIONS[M.Cu3.DIE_CUT['curved-frame-a7']] = 125;
M.Cu3.DIE_CUT.WEDDING_BACKER_LOGO_Y_POSITIONS[M.Cu3.DIE_CUT['tag-a7']] = 115;
M.Cu3.DIE_CUT.WEDDING_BACKER_LOGO_Y_POSITIONS[M.Cu3.DIE_CUT['circle-sq6']] = 210;
M.Cu3.DIE_CUT.WEDDING_BACKER_LOGO_Y_POSITIONS[M.Cu3.DIE_CUT['rounded-corners-a7']] = 115;
M.Cu3.DIE_CUT.WEDDING_BACKER_LOGO_Y_POSITIONS[M.Cu3.DIE_CUT['waved-frame-a7']] = 120;
M.Cu3.DIE_CUT.WEDDING_BACKER_LOGO_Y_POSITIONS[M.Cu3.DIE_CUT['rounded-corners-sq5']] = 200;
M.Cu3.DIE_CUT.WEDDING_BACKER_LOGO_Y_POSITIONS[M.Cu3.DIE_CUT['scalloped-circle-sq5']] = 210;
M.Cu3.DIE_CUT.WEDDING_BACKER_LOGO_Y_POSITIONS[M.Cu3.DIE_CUT['classic-frame-a2']] = 120;
M.Cu3.DIE_CUT.WEDDING_BACKER_LOGO_Y_POSITIONS[M.Cu3.DIE_CUT['oval-scallop-a2']] = 120;
M.Cu3.DIE_CUT.WEDDING_BACKER_LOGO_Y_POSITIONS[M.Cu3.DIE_CUT['notch-a2']] = 210;
M.Cu3.DIE_CUT.WEDDING_BACKER_LOGO_Y_POSITIONS[M.Cu3.DIE_CUT['oval-cloud-scallop-a2']] = 130;
M.Cu3.DIE_CUT.WEDDING_BACKER_LOGO_Y_POSITIONS[M.Cu3.DIE_CUT['bubble-scallop-a2']] = 120;
M.Cu3.DIE_CUT.WEDDING_BACKER_LOGO_Y_POSITIONS[M.Cu3.DIE_CUT['rounded-corners-a2']] = 115;
M.Cu3.DIE_CUT.WEDDING_BACKER_LOGO_Y_POSITIONS[M.Cu3.DIE_CUT['rounded-corners-a2']] = 115;
M.Cu3.DIE_CUT.WEDDING_BACKER_LOGO_Y_POSITIONS[M.Cu3.DIE_CUT['curved-frame-a2']] = 120;
M.Cu3.DIE_CUT.WEDDING_BACKER_LOGO_Y_POSITIONS[M.Cu3.DIE_CUT['scalloped-circle-sq6']] = 205;
M.Cu3.DIE_CUT.WEDDING_BACKER_LOGO_Y_POSITIONS[M.Cu3.DIE_CUT['rounded-corners-sq6']] = 200;
M.Cu3.DIE_CUT.WEDDING_BACKER_LOGO_Y_POSITIONS[M.Cu3.DIE_CUT['arch-a7']] = 115;
M.Cu3.DIE_CUT.WEDDING_BACKER_LOGO_Y_POSITIONS[M.Cu3.DIE_CUT['arch-a2']] = 115;
M.Cu3.DIE_CUT.WEDDING_BACKER_LOGO_Y_POSITIONS[M.Cu3.DIE_CUT['curved-edge-a7']] = 115;

M.Cu3.DIE_CUTS_NAME_MAPPING = M.DIECUT.ATTRIBUTE_NAME_TO_LABEL;

// Photo elements in die cut shape templates need
// to be made smaller by 2px
M.Cu3.DIE_CUT_PHOTO_ELEMENT_WIDTH_REDUCE = 2;

// A list of backer types which is consistent across product kinds.
// These are only ever stored in memory in javascript and are used to
// identify which backers are valid with which die cut shapes (see Bug
// 9758). These values might one day be suitable for insertion into a
// new "saved_design_template.template_content_key" column.  See
// https://reviewboard.minted.com/r/8708/ for some background info The
// integers assigned to these symbolic constants are intentionally
// large to avoid confusion with the literal integer values found in
// drupal/static/src/js/cu3/color_choice_backer_list_factory.js (which
// are currently stored in the database in
// saved_design_template.template_option_key).  If we ever drop
// saved_design_template.template_option_key, we can subtract 1000
// from all of these to re-base them on 0 instead of 1000
M.Cu3.BACKER_BLANK = 1000;
M.Cu3.BACKER_PATTERN = 1001;
// NOTE: This backer will no longer be available on the site starting
// sometime in 2012
M.Cu3.BACKER_1_PHOTO_MINIMAL = 1002;
// NOTE: One of the two solid backers will no longer be available on
// the site starting sometime in 2012
M.Cu3.BACKER_SOLID_1 = 1003;
M.Cu3.BACKER_SOLID_2 = 1004;
M.Cu3.BACKER_3_PHOTO_MINIMAL = 1005;
M.Cu3.BACKER_1_PHOTO_STORYBOARD = 1006;
M.Cu3.BACKER_3_PHOTO_STORYBOARD = 1007;
// NOTE: This backer does not exist yet, but will be created sometime
// in 2012.  See https://bugs.minted.com/show_bug.cgi?id=9758#c1
M.Cu3.BACKER_NOTE = 1008;
// NOTE: This backer does not exist yet, but will be created sometime
// in 2012.  See https://bugs.minted.com/show_bug.cgi?id=9758#c1
// TODO: When more information is available, rename this constant to
// more clearly distinguish it from the other photo backers
M.Cu3.BACKER_PHOTO = 1009;
// NOTE: This backer does not exist yet, but will be created sometime
// in 2012.  See https://bugs.minted.com/show_bug.cgi?id=9758#c1
M.Cu3.BACKER_PHOTO_GRID = 1010;
M.Cu3.BACKER_INFOGRAPHIC = 1011;
M.Cu3.BACKER_FULL_BLEED = 1012;
// NOTE: Added 10/2014.
M.Cu3.BACKER_6_PHOTO_ONLY = 1014;
M.Cu3.BACKER_MULTI_PHOTO_STORY = 1015;
M.Cu3.BACKER_3_PHOTO_TIMELINE = 1016;
M.Cu3.BACKER_2_PHOTO_STORY = 1017;
M.Cu3.BACKER_3_PHOTO_STORY = 1018;
M.Cu3.BACKER_12_MONTH_PHOTO_GRID = 1019;
M.Cu3.MATCH_FRONT = 2121;
// Background Types used in saved_design_template.background_type.
M.Cu3.BackgroundType = {
  BLANK: 1,
  SOLID_LIGHT: 2,
  PATTERN: 3,
  FULL_BLEED: 4,
  MATCH_FRONT: 5,
  PHOTO_ONLY: 6
}

// Shared Backer Layouts and their IDs.
M.Cu3.SharedBackerLayouts = {
  BLANK: 1,
  TEXT_ONLY: 2,
  ONE_PHOTO_TEXT: 3,
  TWO_PHOTO_TEXT: 4,
  THREE_PHOTO_TEXT: 5,
  ONE_PHOTO_LETTER: 6,
  FOUR_PHOTO_TEXT: 7,
  NINE_PHOTO: 8,
  INFOGRAPHIC: 9,
  LOGO_TEXT: 10,
  ONE_PHOTO: 11,
  TWO_PHOTO: 12,
  THREE_PHOTO: 13,
  FOUR_PHOTO: 14,
  FULL_BLEED_PHOTO: 15,
  OTHER: -1
};

// Shared Backer Keys. These will be used in production data to identify backer
// layout options.
M.Cu3.SharedBackerLayoutKeys = {
  'blank': M.Cu3.SharedBackerLayouts.BLANK,
  'text_only': M.Cu3.SharedBackerLayouts.TEXT_ONLY,
  'one_photo_text': M.Cu3.SharedBackerLayouts.ONE_PHOTO_TEXT,
  'two_photo_text': M.Cu3.SharedBackerLayouts.TWO_PHOTO_TEXT,
  'three_photo_text': M.Cu3.SharedBackerLayouts.THREE_PHOTO_TEXT,
  'one_photo_letter': M.Cu3.SharedBackerLayouts.ONE_PHOTO_LETTER,
  'four_photo_text': M.Cu3.SharedBackerLayouts.FOUR_PHOTO_TEXT,
  'nine_photo': M.Cu3.SharedBackerLayouts.NINE_PHOTO,
  'infographic': M.Cu3.SharedBackerLayouts.INFOGRAPHIC,
  'logo_text': M.Cu3.SharedBackerLayouts.LOGO_TEXT,
  'one_photo': M.Cu3.SharedBackerLayouts.ONE_PHOTO,
  'two_photo': M.Cu3.SharedBackerLayouts.TWO_PHOTO,
  'three_photo': M.Cu3.SharedBackerLayouts.THREE_PHOTO,
  'four_photo': M.Cu3.SharedBackerLayouts.FOUR_PHOTO,
  'full_bleed_photo': M.Cu3.SharedBackerLayouts.FULL_BLEED_PHOTO,
  'other': M.Cu3.SharedBackerLayouts.OTHER
};

// Mapping of background names used in production data to BackgroundType
// constants, keep in sync with display_name_to_background_type in
// minted/py/src/minted/model/constants.py
M.Cu3.DisplayNameToBackgroundType = {
  'White': M.Cu3.BackgroundType.BLANK,
  'Solid': M.Cu3.BackgroundType.SOLID_LIGHT,
  'Solid Light': M.Cu3.BackgroundType.SOLID_LIGHT,
  'Pattern': M.Cu3.BackgroundType.PATTERN,
  'Full Bleed': M.Cu3.BackgroundType.FULL_BLEED,
  'Photo Only': M.Cu3.BackgroundType.PHOTO_ONLY,
  'Match Front': M.Cu3.BackgroundType.MATCH_FRONT
};

// Possible ways in which CU3 may be instantiated
// Default is the standard view
M.Cu3.CALLER = {
  'default': 'default',
  'partyIframe': 'party_iframe'
}

// An array of text element ids that are used to identify which text elements
// have their text editing ability disabled.
// The order that these element ids appear is important as it is assumed that
// the first array item correlates to the first textElement and so on.
M.Cu3.PARTY_ITEM_TEXT_EDIT_DISABLED_ELEMENT_IDS = ['text101', 'text102',
    'text103'];

// This enum mirrors the python one in src/py/minted/model/constants.py
// If you change it here, change it there
M.Cu3.SAVED_DESIGN_SPECIAL_ELEMENT_TYPE = {
  STATIC_ELEMENT: 0,
  CUSTOM_COLOR: 1,
}

// NOTE: Maintain in parallel with Scene7Renderer::NOTEBOOK_PAGE_1_FXG
M.FXG = M.FXG || {} ;
M.FXG.NOTEBOOK = {
  GROMMET: {
    FRONT: 'JournalFront',
    INTERIOR: 'JournalInterior-grommet',
    INTERIOR_OPEN: 'JournalInteriorOpen'
  },
  SPIRAL: {
    FRONT: 'JournalFront-spiral',
    INTERIOR: 'JournalInterior-spiral',
    INTERIOR_OPEN: 'JournalInteriorOpen-spiral'
  }
}

var GIFT_TAG_SQUARE = 'GiftTag_BCS';
var GIFT_TAG_LANDSCAPE = 'GiftTag_BCL';
var GIFT_TAG_PORTRAIT = 'GiftTag_BCP';

var GIFT_TAG_SQUARE_BACKER = 'GiftTag_BCS_Backer';
var GIFT_TAG_LANDSCAPE_BACKER = 'GiftTag_BCL_Backer';
var GIFT_TAG_PORTRAIT_BACKER = 'GiftTag_BCP_Backer';

var POSTCARD_LANDSCAPE = 'SPC_BKR_EMBED';
var POSTCARD_PORTRAIT = 'SPC_BKR_EMBED';
var A2_POSTCARD =  'A2Postcard_BKR_EMBED';

var CALENDAR_STANDARD_FXG = 'CalendarEmbed_Standard';
var CALENDAR_GRAND_FXG = 'CalendarEmbed_Grand';

// Below are the FXG file names
var BELLY_BAND_EMBED = 'BellyBand_embed';
var BELLY_BAND_EMBED_PREVIEW = 'BellyBand_preview_embed';

var ONE_PAGE_CALENDAR_EMBED = 'OnePageCalendar_embed';

var STAMP_FXG = {
  ONE_OUNCE: '1-56x1-25_postage_stamp_1-ounce',
  TWO_OUNCE: '1-56x1-25_postage_stamp_2-ounce',
  POSTCARD: '1-56x1-25_postage_stamp_postcard'
};

var STAMP_TIER_TO_FXG_MAP = {};
STAMP_TIER_TO_FXG_MAP[Tier.ONE_OUNCE_STAMP] =  STAMP_FXG.ONE_OUNCE;
STAMP_TIER_TO_FXG_MAP[Tier.TWO_OUNCE_STAMP] =  STAMP_FXG.TWO_OUNCE;
STAMP_TIER_TO_FXG_MAP[Tier.POSTCARD_STAMP] =  STAMP_FXG.POSTCARD;

// This is used to define the regex pattern of text ids
// on the shared templates.
var REGEX_SHARED_TEXT_ID = /^(w?f?[hp][0-9]+):text[0-9]+$/

// Defines a list of SKU's to enable the SVG-based editor.
// NOTE: This is now controlled by product attribute data. DO NOT ADD MORE SKUS
// HERE.
// TODO: Add product attribute data for the following skus and remove this list.
var SKUS_TO_SVG = [
  'MIN-0JM-NCA',
  'MIN-0JN-NCA',
  'MIN-0JO-NCA',
  'MIN-0JP-NCA',
  'MIN-0JQ-NCA',
  'MIN-0JR-NCA',
  'MIN-FI6-HCP',
  'MIN-FI7-HCP',
  'MIN-FJ0-HCP',
  'MIN-FJ1-HCP',
  'MIN-FJ3-HCP',
  'MIN-FJ5-HCP',
  'MIN-FJ7-HCP',
  'MIN-FL9-HCP',
  'MIN-FM1-HCP',
  'MIN-FM2-HCP',
  'MIN-FM5-HCP',
  'MIN-FO0-HCP',
  'MIN-FO6-HCP',
  'MIN-FR0-HCP',
  'MIN-FR9-HCP',
  'MIN-FT4-HCP',
  'MIN-FT9-HCP',
  'MIN-43I-HCP',
  'MIN-4S9-HCP',
  'MIN-X5X-HYC',
  'MIN-X01-HYC',
  'MIN-X2H-HYC',
  'MIN-X20-HYC',
  'MIN-X1E-HYC',
  'MIN-WZC-HYC',
  'MIN-WZK-HYC',
  'MIN-X5T-HYC',
  'MIN-X3R-HYC',
  'MIN-X6Q-HYC',
  'MIN-WYN-HYC',
  'MIN-X6O-HYC',
  'MIN-WYE-HYC',
  'MIN-X1C-HYC',
  'MIN-X08-HYC',
  'MIN-X56-HYC',
  'MIN-WZV-HYC',
  'MIN-X4A-HYC',
  'MIN-X6H-HYC',
  'MIN-X3Q-HYC',
  'MIN-WYQ-HYC',
  'MIN-X6B-HYC',
  'MIN-X1T-HYC',
  'MIN-X3N-HYC',
  'MIN-X04-HYC',
  'MIN-WZM-HYC',
  'MIN-X1P-HYC',
  'MIN-WYC-HYC',
  'MIN-WYA-HYC',
  'MIN-GP7-HYC',
  'MIN-WX5-HYC',
  'MIN-GR2-HYC',
  'MIN-GP5-HYC',
  'MIN-X44-HYC',
  'MIN-3U6-HPC',
  'MIN-3R1-HPC',
  'MIN-3M3-HPC',
  'MIN-5U9-HPC',
  'MIN-HC5-HPC',
  'MIN-X5P-HYC',
  'MIN-X5Y-HYC',
  'MIN-X2X-HYC',
  'MIN-X6A-HYC',
  'MIN-X5A-HYC',
  'MIN-WWR-HYC',
  'MIN-WZ0-HYC',
  'MIN-X71-HYC',
  'MIN-X19-HYC',
  'MIN-WY5-HYC',
  'MIN-WZ9-HYC',
  'MIN-X6E-HYC',
  'MIN-X6F-HYC',
  'MIN-WYX-HYC',
  'MIN-X65-HYC',
  'MIN-X1X-HYC',
  'MIN-AS9-BYA',
  'MIN-BB1-SMG',
  'MIN-AY5-SPC',
  'MIN-4O2-PAR',
  'MIN-08X-KCA',
  'MIN-08Y-KCA',
  'MIN-08Z-KCA',
  'MIN-090-KCA',
  'MIN-091-KCA',
  'MIN-092-KCA',
  'MIN-093-KCA',
  'MIN-08L-KCA',
  'MIN-08M-KCA',
  'MIN-08N-KCA',
  'MIN-08O-KCA',
  'MIN-08P-KCA',
  'MIN-08Q-KCA',
  'MIN-08R-KCA',
  'MIN-08S-KCA',
  'MIN-08T-KCA',
  'MIN-08U-KCA',
  'MIN-08V-KCA',
  'MIN-08W-KCA',
  'MIN-0AC-KCA',
  'MIN-0AD-KCA',
  'MIN-0AE-KCA',
  'MIN-0AF-KCA',
  'MIN-0AG-KCA',
  'MIN-0AH-KCA',
  'MIN-0AI-KCA',
  'MIN-09M-KCA',
  'MIN-09N-KCA',
  'MIN-09O-KCA',
  'MIN-09P-KCA',
  'MIN-09Q-KCA',
  'MIN-0MO-NCA',
  'MIN-0MP-NCA',
  'MIN-0MQ-NCA',
  'MIN-0MR-NCA',
  'MIN-0MS-NCA',
  'MIN-0MT-NCA',
  'MIN-0NF-NCA',
  'MIN-0NG-NCA',
  'MIN-0NH-NCA',
  'MIN-0NI-NCA',
  'MIN-0NJ-NCA',
  'MIN-0NK-NCA',
  'MIN-0NL-NCA',
  'MIN-0NT-NCA',
  'MIN-0NU-NCA',
  'MIN-0NV-NCA',
  'MIN-0NW-NCA',
  'MIN-0NX-NCA',
  'MIN-0NY-NCA',
  'MIN-0NZ-NCA',
  'MIN-0N1-NCA',
  'MIN-0N2-NCA',
  'MIN-0N3-NCA',
  'MIN-0N4-NCA',
  'MIN-0N5-NCA',
  'MIN-0N6-NCA',
  'MIN-0N7-NCA',
  'MIN-O62-BYA',
  'MIN-L13-BYA',
  'MIN-0W5-GRY',
  'MIN-0X2-GRY',
  'MIN-1E5-GRY',
  'MIN-0X7-GJB',
  'MIN-0X8-GJB',
  'MIN-0U9-GRT',
  'MIN-0S8-GRT',
  'MIN-0T4-GRT',
  'MIN-1B9-GRT',
  'MIN-62Z-TYC',
  'MIN-54Z-TYC',
  'MIN-86Z-TYC',
  'MIN-73Z-TYC',
  'MIN-40Z-TYC',
  'MIN-22Z-TYC',
  'MIN-20Z-TYC',
  'MIN-0C0-TYC',
  'MIN-0B8-TYC',
  'MIN-0B7-TYC',
  'MIN-0A6-TYC',
  'MIN-84Z-TYC',
  'MIN-48Z-TYC',
  'MIN-29Z-TYC',
  'MIN-52Z-TYC',
  'MIN-98Y-CBP',
  'MIN-J26-HNP',
  'MIN-D49-HYC',
  'MIN-I96-CHR',
  'MIN-J33-HYC',
  'MIN-15K-NBK',
  'MIN-I74-NBK',
  'MIN-J01-NBK',
  'MIN-J06-NBK',
  'MIN-J09-NBK',
  'MIN-J92-BYA',
  'MIN-K16-BYA',
  'MIN-K59-BYA',
  'MIN-K63-BYA',
  'MIN-04J-KST',
  'MIN-20J-KST',
  'MIN-56K-GFT',
  'MIN-60K-GFT',
  'MIN-72K-GFT',
  'MIN-88K-GFT',
  'MIN-16L-GFT',
  'MIN-L07-STD',
  'MIN-K99-STD',
  'MIN-MDE-STD',
  'MIN-M63-STD',
  'MIN-LFP-STD',
  'MIN-FOU-STD',
  'MIN-L12-STD',
  'MIN-23R-SPC',
  'MIN-31R-SPC',
  'MIN-36R-SPC',
  'MIN-41R-SPC',
  'MIN-42R-SPC',
  'MIN-15R-SPC',
  'MIN-17R-SPC',
  'MIN-18R-SPC',
  'MIN-19R-SPC',
  'MIN-20R-SPC',
  'MIN-21R-SPC',
  'MIN-22R-SPC',
  'MIN-23R-SPC',
  'MIN-24R-SPC',
  'MIN-25R-SPC',
  'MIN-26R-SPC',
  'MIN-27R-SPC',
  'MIN-28R-SPC',
  'MIN-29R-SPC',
  'MIN-30R-SPC',
  'MIN-31R-SPC',
  'MIN-32R-SPC',
  'MIN-33R-SPC',
  'MIN-34R-SPC',
  'MIN-35R-SPC',
  'MIN-36R-SPC',
  'MIN-37R-SPC',
  'MIN-38R-SPC',
  'MIN-39R-SPC',
  'MIN-40R-SPC',
  'MIN-41R-SPC',
  'MIN-42R-SPC',
  /*
   * INV
   */
  'MIN-40P-INV',
  'MIN-03P-INV',
  'MIN-02R-INV',
  'MIN-06P-INV',
  'MIN-08P-INV',
  'MIN-09P-INV',
  'MIN-28P-INV',
  'MIN-18P-INV',
  'MIN-21P-INV',
  'MIN-25P-INV',
  'MIN-44P-INV',
  'MIN-65O-INV',
  'MIN-70O-INV',
  'MIN-72O-INV',
  'MIN-78O-INV',
  'MIN-90O-INV',
  'MIN-98O-INV',
  'MIN-55P-INV',
  'MIN-69P-INV',
  'MIN-59P-INV',
  'MIN-63P-INV',
  'MIN-65P-INV',
  'MIN-73P-INV',
  'MIN-62P-INV',
  'MIN-80O-INV',
  'MIN-50P-INV',
  'MIN-64P-INV',
  'MIN-86P-INV',
  'MIN-93P-INV',
  'MIN-10Q-INV',
  'MIN-25Q-INV',
  'MIN-31Q-INV',
  'MIN-32Q-INV',
  'MIN-43Q-INV',
  'MIN-45Q-INV',
  'MIN-59Q-INV',
  'MIN-76Q-INV',
  'MIN-85Q-INV',
  'MIN-67O-INV',
  'MIN-84O-INV',
  'MIN-85O-INV',
  'MIN-86O-INV',
  'MIN-77O-INV',
  'MIN-70P-INV',
  'MIN-88Q-INV',
  'MIN-33P-INV',
  'MIN-46R-INV',
  'MIN-61R-INV',
  'MIN-74R-INV',
  'MIN-78Q-INV',
  'MIN-87R-INV',
  'MIN-K85-INV',
  'MIN-52R-INV',
  'MIN-62R-INV',
  'MIN-78R-INV',
  'MIN-88R-INV',
  'MIN-24S-INV',
  'MIN-89R-INV',
  'MIN-29S-INV',
  'MIN-50P-INV',
  'MIN-45Q-INV',
  'MIN-88Q-INV',
  'MIN-45Q-INV',
  'MIN-69P-INV',
  'MIN-70P-INV',
  'MIN-32P-INV',
  'MIN-61T-PAR',
  'MIN-73T-EAS',
  'MIN-84O-INV',
  'MIN-85O-INV',
  'MIN-32P-INV',
  'MIN-J48-INV',
  'MIN-64R-INV',
  'MIN-16S-INV',
  'MIN-65R-INV',
  'MIN-00S-INV',
  'MIN-32S-INV',
  'MIN-31S-INV',
  'MIN-82R-INV',
  'MIN-84R-INV',
  'MIN-53S-STD',
  'MIN-55S-STD',
  'MIN-56S-STD',
  'MIN-61S-STD',
  'MIN-97S-STD',
  'MIN-98S-STD',
  'MIN-WEF-INV',
  'MIN-WFL-INV',
  'MIN-85O-INV',
  'MIN-65R-INV',
  'MIN-95R-INV',
  'MIN-73T-EAS',
  'MIN-76T-EAS',
  'MIN-77T-EAS',
  'MIN-80T-EAS',
  'MIN-61T-PAR',
  'MIN-80S-STD',
  'MIN-54S-STD',
  'MIN-85S-STD',
  'MIN-68S-STD',
  'MIN-69S-STD',
  'MIN-86S-STD',
  'MIN-89S-STD',
  'MIN-03T-STD',
  'MIN-15T-STD',
  'MIN-18T-STD',
  'MIN-20T-STD',
  'MIN-29T-STD',
  'MIN-35T-STD',
  'MIN-32T-STD',
  'MIN-37T-STD',
  'MIN-41T-STD',
  'MIN-40T-STD',
  'MIN-71S-STD',
  'MIN-56T-STD',
  'MIN-34W-PGR',
  'MIN-00C-FCA',
  'MIN-00H-FCA',
  'MIN-001-NCA',
  'MIN-017-NCA',
  'MIN-02A-NCA',
  'MIN-29W-PGR',
  'MIN-33W-PGR',
  'MIN-36W-PGR',
  'MIN-65W-PGR',
  'MIN-59W-PGR',
  'MIN-55V-PST',
  'MIN-69V-PST',
  'MIN-71V-PST',
  'MIN-72V-PST',
  'MIN-85V-PST',
  'MIN-22V-PST',
  'MIN-35V-PST',
  'MIN-40V-PST',
  'MIN-44V-PST',
  'MIN-79U-NBK',
  'MIN-92U-NBK',
  'MIN-61U-NBK',
  'MIN-09V-NBK',
  'MIN-67U-NBK',
  'MIN-00V-NBK',
  'MIN-71S-STD',
  'MIN-46U-STD',
  'MIN-38U-STD',
  'MIN-06M-BSC',
  'MIN-18O-BST',
  'MIN-56L-BSC',
  'MIN-16M-BSC',
  'MIN-81N-BST',
  'MIN-00D-FCA',
  'MIN-00E-FCA',
  'MIN-00N-FCA',
  'MIN-00F-FCA',
  'MIN-00G-FCA',
  'MIN-00I-FCA',
  'MIN-00J-FCA',
  'MIN-00K-FCA',
  'MIN-00L-FCA',
  'MIN-00M-FCA',
  'MIN-002-NCA',
  'MIN-003-NCA',
  'MIN-004-NCA',
  'MIN-005-NCA',
  'MIN-006-NCA',
  'MIN-007-NCA',
  'MIN-018-NCA',
  'MIN-019-NCA',
  'MIN-01A-NCA',
  'MIN-01B-NCA',
  'MIN-01C-NCA',
  'MIN-01D-NCA',
  'MIN-02B-NCA',
  'MIN-02C-NCA',
  'MIN-02D-NCA',
  'MIN-02E-NCA',
  'MIN-02F-NCA',
  'MIN-02G-NCA',
  'MIN-0GX-NCA',
  'MIN-0GY-NCA',
  'MIN-0GZ-NCA',
  'MIN-0H0-NCA',
  'MIN-0H1-NCA',
  'MIN-0H2-NCA',
  'MIN-0H3-NCA',
  'MIN-0HU-NCA',
  'MIN-0HV-NCA',
  'MIN-0HW-NCA',
  'MIN-0HX-NCA',
  'MIN-0HY-NCA',
  'MIN-0HZ-NCA',
  'MIN-0I0-NCA',
  'MIN-03J-KCA',
  'MIN-03K-KCA',
  'MIN-03L-KCA',
  'MIN-03M-KCA',
  'MIN-03N-KCA',
  'MIN-03O-KCA',
  'MIN-03P-KCA',
  'MIN-03Q-KCA',
  'MIN-03R-KCA',
  'MIN-03S-KCA',
  'MIN-03T-KCA',
  'MIN-03U-KCA',
  'MIN-03V-KCA',
  'MIN-03W-KCA',
  'MIN-07X-NCA',
  'MIN-07Y-NCA',
  'MIN-07Z-NCA',
  'MIN-080-NCA',
  'MIN-081-NCA',
  'MIN-082-NCA',
  'MIN-0AN-NCA',
  'MIN-0AO-NCA',
  'MIN-0AP-NCA',
  'MIN-0AQ-NCA',
  'MIN-0AR-NCA',
  'MIN-0AS-NCA',
  'MIN-0AT-NCA',
  'MIN-0AU-NCA',
  'MIN-0AV-NCA',
  'MIN-0AW-NCA',
  'MIN-0AX-NCA',
  'MIN-0AY-NCA',
  'MIN-0AZ-NCA',
  'MIN-0B0-NCA',
  'MIN-00W-FCA',
  'MIN-00X-FCA',
  'MIN-00Y-FCA',
  'MIN-00Z-FCA',
  'MIN-010-FCA',
  'MIN-0BD-NCA',
  'MIN-0BE-NCA',
  'MIN-0BF-NCA',
  'MIN-0BG-NCA',
  'MIN-0BH-NCA',
  'MIN-0BI-NCA',
  'MIN-0BJ-NCA',
  'MIN-0BQ-NCA',
  'MIN-0BR-NCA',
  'MIN-0BS-NCA',
  'MIN-0BT-NCA',
  'MIN-0BU-NCA',
  'MIN-0BV-NCA',
  'MIN-0BW-NCA',
  'MIN-0BX-NCA',
  'MIN-0BY-NCA',
  'MIN-0BZ-NCA',
  'MIN-0C0-NCA',
  'MIN-0C1-NCA',
  'MIN-0C2-NCA',
  'MIN-0C3-NCA',
  'MIN-0C4-NCA',
  'MIN-0C5-NCA',
  'MIN-0C6-NCA',
  'MIN-0C7-NCA',
  'MIN-0C8-NCA',
  'MIN-05G-KCA',
  'MIN-05H-KCA',
  'MIN-05I-KCA',
  'MIN-05J-KCA',
  'MIN-05K-KCA',
  'MIN-05L-KCA',
  'MIN-0DS-NCA',
  'MIN-0DT-NCA',
  'MIN-0DU-NCA',
  'MIN-0DV-NCA',
  'MIN-0DW-NCA',
  'MIN-0DX-NCA',
  'MIN-28X-NBK',
  'MIN-J99-BYA',
  'MIN-J99-BTY',
  'MIN-K01-BYA',
  'MIN-K01-BTY',
  'MIN-J92-BYA',
  'MIN-J92-BTY',
  'MIN-K59-BYA',
  'MIN-K59-BTY',
  'MIN-K63-BYA',
  'MIN-K63-BTY',
  'MIN-01P-FCA',
  'MIN-01Q-FCA',
  'MIN-01R-FCA',
  'MIN-01S-FCA',
  'MIN-01T-FCA',
  'MIN-01U-FCA',
  'MIN-01V-FCA',
  'MIN-01W-FCA',
  'MIN-01X-FCA',
  'MIN-01Y-FCA',
  'MIN-024-FCA',
  'MIN-025-FCA',
  'MIN-026-FCA',
  'MIN-027-FCA',
  'MIN-028-FCA',
  'MIN-49X-MVA',
  'MIN-60X-MVA',
  'MIN-92X-MVA',
  'MIN-63X-MVA',
  'MIN-67X-MVA',
  'MIN-54X-MVA',
  'MIN-15Y-TYC',
  'MIN-19X-PAR',
  'MIN-68X-CBP',
  'MIN-79Y-CBP',
  'MIN-91Y-CBP',
  'MIN-58Y-CBP',
  'MIN-97Y-CBP',
  'MIN-98Y-CBP',
  'MIN-43X-CBP',
  'MIN-44X-CBP',
  'MIN-60X-CBP',
  'MIN-96X-INV',
  'MIN-78X-CBP',
  'MIN-97Y-CBP',
  'MIN-43X-CBP',
  'MIN-44X-CBP',
  'MIN-60X-CBP',
  'MIN-98Y-CBP',
  'MIN-05X-PAR',
  'MIN-79X-CBP',
  'MIN-25X-CBP',
  'MIN-19X-PAR',
  'MIN-79Y-CBP',
  'MIN-91Y-CBP',
  'MIN-58Y-CBP',
  'MIN-78X-CBP',
  'MIN-05Y-BSH',
  'MIN-10Y-BSH',
  'MIN-27Y-BSH',
  'MIN-99X-BSH',
  'MIN-19Y-BSH',
  'MIN-20Y-BSH',
  'MIN-62Y-BSH',
  'MIN-08Y-BSH',
  'MIN-22Y-BSH',
  'MIN-32Y-BSH',
  'MIN-31Y-BSH',
  'MIN-67Y-BSH',
  'MIN-98X-BSH',
  'MIN-45Y-BSH',
  'MIN-46Y-BSH',
  'MIN-74Y-BSH',
  'MIN-72Y-BSH',
  'MIN-73Y-BSH',
  'MIN-30Y-BSH',
  'MIN-47Y-BSH',
  'MIN-48Y-BSH',
  'MIN-43Y-BSH',
  'MIN-86Y-BSH',
  'MIN-95Y-BSH',
  'MIN-24Y-BSH',
  'MIN-26Y-BSH',
  'MIN-83Y-BSH',
  'MIN-84Y-BSH',
  'MIN-66X-CBP',
  'MIN-66X-CTY',
  'MIN-98Y-CBP',
  'MIN-98Y-CTY',
  'MIN-58Y-CTY',
  'MIN-78X-CTY',
  'MIN-05Y-HTY',
  'MIN-27Y-HTY',
  'MIN-99X-HTY',
  'MIN-08Y-HTY',
  'MIN-22Y-HTY',
  'MIN-31Y-HTY',
  'MIN-67Y-HTY',
  'MIN-98X-HTY',
  'MIN-72Y-HTY',
  'MIN-73Y-HTY',
  'MIN-48Y-HTY',
  'MIN-95Y-HTY',
  'MIN-84Y-HTY',
  'MIN-24Y-HTY',
  'MIN-48Z-TYC',
  'MIN-29Z-TYC',
  'MIN-52Z-TYC',
  'MIN-0Q9-EID',
  'MIN-32C-HYC',
  'MIN-AKD-HYC',
  'MIN-E71-HYC',
  'MIN-D85-HYC',
  'MIN-D49-HYC',
  'MIN-E97-HYC',
  'MIN-90D-HYC',
  'MIN-1H3-HYC',
  'MIN-1H4-HYC',
  'MIN-0G2-HCP',
  'MIN-0E3-HCP',
  'MIN-0I3-HCP',
  'MIN-0G5-HCP',
  'MIN-0H5-HCP',
  'MIN-0N2-HCP',
  'MIN-0H8-HCP',
  'MIN-0E4-HCP',
  'MIN-0O2-HCP',
  'MIN-0M7-HCP',
  'MIN-0J9-HCP',
  'MIN-0F0-HCP',
  'MIN-0N4-HCP',
  'MIN-0G1-HCP',
  'MIN-93Y-BSH',
  'MIN-10Z-BSH',
  'MIN-1J1-HYC',
  'MIN-1V9-HYC',
  'MIN-1T4-HYC',
  'MIN-1U2-HYC',
  'MIN-1I6-HYC',
  'MIN-1Z1-HYC',
  'MIN-2E2-HYC',
  'MIN-1O1-HYC',
  'MIN-1X4-HYC',
  'MIN-1T7-HYC',
  'MIN-1W0-HYC',
  'MIN-1P0-HYC',
  'MIN-1W1-HYC',
  'MIN-2E4-HYC',
  'MIN-2I1-HYC',
  'MIN-3T3-HPC',
  'MIN-3K6-HPC',
  'MIN-3K8-HPC',
  'MIN-3M2-HPC',
  'MIN-3M3-HPC',
  'MIN-3M4-HPC',
  'MIN-3M6-HPC',
  'MIN-3M7-HPC',
  'MIN-3M8-HPC',
  'MIN-3N1-HPC',
  'MIN-3N5-HPC',
  'MIN-3N7-HPC',
  'MIN-3O0-HPC',
  'MIN-3O2-HPC',
  'MIN-3I9-HPC',
  'MIN-3O5-HPC',
  'MIN-3O6-HPC',
  'MIN-3P6-HPC',
  'MIN-3Q2-HPC',
  'MIN-3Q3-HPC',
  'MIN-3Q9-HPC',
  'MIN-3R0-HPC',
  'MIN-3R5-HPC',
  'MIN-3S4-HPC',
  'MIN-3S9-HPC',
  'MIN-3T5-HPC',
  'MIN-3U7-HPC',
  'MIN-3I4-HPC',
  'MIN-3I6-HPC',
  'MIN-3I8-HPC',
  'MIN-3J0-HPC',
  'MIN-3J2-HPC',
  'MIN-3J6-HPC',
  'MIN-3K2-HPC',
  'MIN-3K3-HPC',
  'MIN-3K7-HPC',
  'MIN-3K9-HPC',
  'MIN-3L1-HPC',
  'MIN-3L3-HPC',
  'MIN-3L7-HPC',
  'MIN-3N0-HPC',
  'MIN-3I5-HPC',
  'MIN-3I7-HPC',
  'MIN-3J3-HPC',
  'MIN-3J5-HPC',
  'MIN-3J7-HPC',
  'MIN-3J8-HPC',
  'MIN-3J9-HPC',
  'MIN-3K0-HPC',
  'MIN-3K1-HPC',
  'MIN-3L0-HPC',
  'MIN-3L2-HPC',
  'MIN-3L4-HPC',
  'MIN-3L5-HPC',
  'MIN-3K4-HPC',
  'MIN-3K5-HPC',
  'MIN-3J4-HPC',
  'MIN-3L8-HPC',
  'MIN-3L9-HPC',
  'MIN-3M1-HPC',
  'MIN-3M5-HPC',
  'MIN-3M9-HPC',
  'MIN-3N2-HPC',
  'MIN-3N9-HPC',
  'MIN-3L6-HPC',
  'MIN-3M0-HPC',
  'MIN-3N4-HPC',
  'MIN-3N6-HPC',
  'MIN-3O4-HPC',
  'MIN-3O7-HPC',
  'MIN-3O9-HPC',
  'MIN-3P1-HPC',
  'MIN-3P4-HPC',
  'MIN-3P5-HPC',
  'MIN-3P7-HPC',
  'MIN-3P8-HPC',
  'MIN-3P9-HPC',
  'MIN-3Q1-HPC',
  'MIN-3Q4-HPC',
  'MIN-3Q5-HPC',
  'MIN-3Q8-HPC',
  'MIN-3T9-HPC',
  'MIN-3U0-HPC',
  'MIN-3U4-HPC',
  'MIN-3U6-HPC',
  'MIN-3J1-HPC',
  'MIN-3N3-HPC',
  'MIN-3N8-HPC',
  'MIN-3O1-HPC',
  'MIN-3O3-HPC',
  'MIN-3P0-HPC',
  'MIN-3P2-HPC',
  'MIN-3P3-HPC',
  'MIN-3Q0-HPC',
  'MIN-3R1-HPC',
  'MIN-3R2-HPC',
  'MIN-3R3-HPC',
  'MIN-3R4-HPC',
  'MIN-3R6-HPC',
  'MIN-3S6-HPC',
  'MIN-3S8-HPC',
  'MIN-3O8-HPC',
  'MIN-3Q6-HPC',
  'MIN-3Q7-HPC',
  'MIN-3R7-HPC',
  'MIN-3R8-HPC',
  'MIN-3R9-HPC',
  'MIN-3S0-HPC',
  'MIN-3S1-HPC',
  'MIN-3S2-HPC',
  'MIN-3S3-HPC',
  'MIN-3S5-HPC',
  'MIN-3S7-HPC',
  'MIN-3T0-HPC',
  'MIN-3T1-HPC',
  'MIN-3T2-HPC',
  'MIN-3T4-HPC',
  'MIN-3T6-HPC',
  'MIN-3T7-HPC',
  'MIN-3T8-HPC',
  'MIN-3U1-HPC',
  'MIN-3U2-HPC',
  'MIN-3U3-HPC',
  'MIN-3U5-HPC',
  'MIN-2K9-CHC',
  'MIN-3C1-CHC',
  'MIN-3A5-CHC',
  'MIN-50F-CHC',
  'MIN-I83-CHC',
  'MIN-08F-CHC',
  'MIN-G36-CHC',
  'MIN-00G-CHC',
  'MIN-10G-CHC',
  'MIN-20G-CHC',
  'MIN-23F-CHC',
  'MIN-3G1-HNC',
  'MIN-3G3-HNC',
  'MIN-4W7-PT2',
  'MIN-2E6-HYC',
  'MIN-4Y6-HNY',
  'MIN-5D8-HNY',
  'MIN-5D5-HNY',
  'MIN-5N6-HNY',
  'MIN-HDL-HNY',
  'MIN-19I-HNY',
  'MIN-97H-HNY',
  'MIN-5L0-CBP',
  'MIN-0E3-HCP',
  'MIN-93Y-BSH',
  'MIN-26Y-BSH',
  'MIN-10Z-BSH',
  'MIN-4V0-HNP',
  'MIN-F85-CHR',
  'MIN-51F-CHR',
  'MIN-G43-CHR',
  'MIN-53F-CHR',
  'MIN-10G-CHR',
  'MIN-20G-CHR',
  'MIN-4W7-PTS',
  'MIN-5L5-HPA',
  'MIN-7U5-INV',
  'MIN-7U5-RSV',
  'MIN-7U6-STD',
  'MIN-7V7-INV',
  'MIN-7W9-INV',
  'MIN-7W2-INV',
  'MIN-7W3-INV',
  'MIN-7W6-INV',
  'MIN-7W7-INV',
  'MIN-7W8-INV',
  'MIN-7X3-INV',
  'MIN-7X5-INV',
  'MIN-7X6-INV',
  'MIN-7X8-INV',
  'MIN-7Y0-INV',
  'MIN-7X0-INV',
  'MIN-7Y5-INV',
  'MIN-7V5-INV',
  'MIN-7Z3-INV',
  'MIN-7W4-INV',
  'MIN-8A8-INV',
  'MIN-8C2-INV',
  'MIN-8K9-STD',
  'MIN-8L0-STD',
  'MIN-8L1-STD',
  'MIN-8L4-STD',
  'MIN-8M3-STD',
  'MIN-8M4-STD',
  'MIN-8N0-STD',
  'MIN-8N5-STD',
  'MIN-8N9-STD',
  'MIN-8P2-STD',
  'MIN-8P5-STD',
  'MIN-8Q1-STD',
  'MIN-8Q2-STD',
  'MIN-8Q5-STD',
  'MIN-8Q6-STD',
  'MIN-K58-INV',
  'MIN-L61-INV',
  'MIN-K76-INV',
  'MIN-7V2-STD',
  'MIN-7V4-STD',
  'MIN-7Q3-SPC',
  'MIN-7Q8-SPC',
  'MIN-7R8-SPC',
  'MIN-7S1-SPC',
  'MIN-7S5-SPC',
  'MIN-7S8-SPC',
  'MIN-7T2-SPC',
  'MIN-7T7-SPC',
  'MIN-5M7-PAR',
  'MIN-5K8-CBP',
  'MIN-7O3-BSH',
  'MIN-7O2-BSH',
  'MIN-6W5-PST',
  'MIN-6X4-PST',
  'MIN-58O-INV',
  'MIN-5X4-HNY',
  'MIN-5P2-HYC',
  'MIN-6I1-HNP',
  'MIN-5O4-HNY',
  'MIN-6C9-GFT',
  'MIN-5Q9-HNY',
  'MIN-4J7-HNP',
  'MIN-H91-HNP',
  'MIN-5U4-HPC',
  'MIN-5X8-CBP',
  'MIN-6E0-HPA',
  'MIN-5M2-HPA',
  'MIN-5G4-PAR',
  'MIN-T2Q-GCA',
  'MIN-T2R-GCA',
  'MIN-T2S-GCA',
  'MIN-T2T-GCA',
  'MIN-T2U-GCA',
  'MIN-T2V-GCA',
  'MIN-T2W-GCA',
  'MIN-5U9-HPC',
  'MIN-5T6-HPC',
  'MIN-5D2-HNY',
  'MIN-5F2-HNY',
  'MIN-5C4-HNY',
  'MIN-4Y4-HNY',
  'MIN-6A3-GFT',
  'MIN-6B6-GFT',
  'MIN-8F2-INV',
  'MIN-8F5-INV',
  'MIN-8C1-INV',
  'MIN-8F1-INV',
  'MIN-7Z7-INV',
  'MIN-7Z5-INV',
  'MIN-7Z2-INV',
  'MIN-7Z9-INV',
  'MIN-8A4-INV',
  'MIN-8A6-INV',
  'MIN-8A7-INV',
  'MIN-8A9-INV',
  'MIN-8B2-INV',
  'MIN-8B4-INV',
  'MIN-8B9-INV',
  'MIN-8C0-INV',
  'MIN-8C8-INV',
  'MIN-8B6-INV',
  'MIN-8D7-INV',
  'MIN-8E9-INV',
  'MIN-8G3-INV',
  'MIN-8G5-INV',
  'MIN-8H1-INV',
  'MIN-8U3-STD',
  'MIN-8L8-STD',
  'MIN-8N7-STD',
  'MIN-8P1-STD',
  'MIN-8O4-STD',
  'MIN-8R8-STD',
  'MIN-8R1-STD',
  'MIN-8K5-STD',
  'MIN-8N1-STD',
  'MIN-8T0-STD',
  'MIN-8T3-STD',
  'MIN-8U1-STD',
  'MIN-8W0-STD',
  'MIN-8Z4-STD',
  'MIN-9B0-SMG',
  'MIN-9B5-SMG',
  'MIN-9D1-SMG',
  'MIN-9D8-SMG',
  'MIN-9E4-SMG',
  'MIN-9F3-SMG',
  'MIN-9C5-SMG',
  'MIN-9C7-SMG',
  'MIN-9D4-SMG',
  'MIN-9G8-SMG',
  'MIN-9H1-SMG',
  'MIN-9T0-GVD',
  'MIN-9U4-GVD',
  'MIN-9N8-VLD',
  'MIN-9P2-VLD',
  'MIN-9J0-CVD',
  'MIN-9J9-CVD',
  'MIN-0JQ-NCA',
  'MIN-AK9-BYA',
  'MIN-AQ1-BYA',
  'MIN-AO1-BYA',
  'MIN-AK7-BYA',
  'MIN-AL6-BYA',
  'MIN-AQ2-BYA',
  'MIN-AI6-BYA',
  'MIN-AI9-BYA',
  'MIN-AI8-BYA',
  'MIN-AL0-BYA',
  'MIN-AN2-BYA',
  'MIN-AK6-BYA',
  'MIN-AI0-BYA',
  'MIN-AK3-BYA',
  'MIN-AI3-BYA',
  'MIN-AI1-BYA',
  'MIN-AW0-BYA',
  'MIN-AK1-BYA',
  'MIN-AM5-BYA',
  'MIN-AN5-BYA',
  'MIN-AN6-BYA',
  'MIN-AO5-BYA',
  'MIN-AQ3-BYA',
  'MIN-AR2-BYA',
  'MIN-AR5-BYA',
  'MIN-AR8-BYA',
  'MIN-AS5-BYA',
  'MIN-AV1-BYA',
  'MIN-AV2-BYA',
  'MIN-8P0-STD',
  'MIN-AA4-BPC',
  'MIN-AB2-BPC',
  'MIN-AB9-BPC',
  'MIN-AG4-BPC',
  'MIN-AD1-BMG',
  'MIN-AD9-BMG',
  'MIN-AE6-BMG',
  'MIN-AH3-BMG',
  'MIN-8E1-INV',
  'MIN-7X7-INV',
  'MIN-8J5-INV',
  'MIN-8F3-INV',
  'MIN-8K1-INV',
  'MIN-7Y8-INV',
  'MIN-8E6-INV',
  'MIN-8D6-INV',
  'MIN-8D4-INV',
  'MIN-7Z4-INV',
  'MIN-8A0-INV',
  'MIN-8D2-INV',
  'MIN-8D5-INV',
  'MIN-8H4-INV',
  'MIN-8J0-INV',
  'MIN-8J3-INV',
  'MIN-8K2-INV'
// NOTE: Do not add more skus to this list. Enable SVG through product attribute
// data instead.
];

var EnvelopeRapOption = {
  NONE: 1,
  SKINNYWRAP: 2,
  RAP: 3
};

// RCP_TODO: ughhh, refactor out the need for return_address_print
// A mapping between the selected RAP option (none, skinnywrap, or printed)
// and saved_design.return_address_print
M.EnvelopeRapOptionToReturnAddressPrint = {};
M.EnvelopeRapOptionToReturnAddressPrint[EnvelopeRapOption.NONE] = null;
M.EnvelopeRapOptionToReturnAddressPrint[EnvelopeRapOption.SKINNYWRAP] = 'skinnyAddressLabels';
M.EnvelopeRapOptionToReturnAddressPrint[EnvelopeRapOption.RAP] = 'RAP';

var EnvelopeRcpOption = {
  NONE: 1,
  RCP: 2
};
var EnvelopeOptionType = {
  COLOR: 1,
  LINER: 2,
  RAP: 3,
  RCP: 4,
  STAMPS: 5,
  COORDINATING_LINER: 6,
};

// The front end is just a pass-through, only need to define degenerate case.
// The python code handles the main logic
var RCP_RECIPIENT_TYPE = {
  NONE: 0,
}

var StampOption = {
  NONE: 1,
  ONE_OUNCE: 2,
  TWO_OUNCE: 3,
  POSTCARD: 4
};

var TierToStampOption = {};
TierToStampOption[Tier.ONE_OUNCE_STAMP] = StampOption.ONE_OUNCE;
TierToStampOption[Tier.TWO_OUNCE_STAMP] = StampOption.TWO_OUNCE;
TierToStampOption[Tier.POSTCARD_STAMP] = StampOption.POSTCARD;

var BackerType = {
  PHOTO_LETTER: 'photo-letter',
  SOLID: 'solid',
  PATTERN: 'pattern',
  BLANK: 'none',
  TEXT_ONLY: 'text-only',
  // TODO: clean the data/code to unify the format of match front data
  MATCH_FRONT: 'match-front',
  MATCH_FRONT_ALT: 'match front',
  PHOTO_ONLY: 'photo-only'
};

var SHARED_MAP_TYPE = {
  BACKER: 1,
  INTERIOR: 2,
  CUSTOM_INTERIOR: 3
};

var CARD_INTERIOR_TEMPLATE_TYPES = ['INTERIOR', 'CUSTOM_INTERIOR']

var Scene7ParamKeyPrefix = {
  ELEMENT: "Element",
  ATTR   : "Attr"
};

var Scene7ParamKey = {
  ENVELOPE_COLOR_OPTION: 'ENVELOPE_COLOR_OPTION',
  ENVELOPE_RAP_OPTION  : 'ENVELOPE_RAP_OPTION',
  ENVELOPE_RCP_OPTION  : 'ENVELOPE_RCP_OPTION',
  SKINNYWRAP_LABEL     : 'SKINNYWRAP_LABEL',
  SKINNYWRAP_SOURCE    : 'SKINNYWRAP_SOURCE',
  LINER_OPTION         : 'LINER_OPTION',
  LINER_SOURCE         : 'LINER_SOURCE'
};


var TOOLTIP_LOCAL_STORE_KEY = {
  // RCP_TWO and STAMP_TWO are now the source of truth.
  // RCP & STAMP can be removed after transition period.
  RCP: 'RCP_SKU',
  RCP_TWO: 'RCP_SKUS',
  STAMP: 'STAMP_SKU',
  STAMP_TWO: 'STAMP_SKUS'
};

// The FXG element ids associated with RAP text elements in the
// envelope frame in CU3
// NOTE: do not assume that skinnywrap has only two text elements;
// it often has fewer or more
M.Cu3.ENVELOPE_RAP_ELEMENT_IDS = ['text8', 'text9', 'text11'];
M.Cu3.ENVELOPE_BACK_RAP_ELEMENT_IDS = ['text8', 'text9'];
M.Cu3.ENVELOPE_BACK_RAP_NAME_ELEMENT_ID = 'text8';
M.Cu3.ENVELOPE_BACK_RAP_RETURN_ADDRESS_ELEMENT_ID = 'text9';
M.Cu3.ENVELOPE_SKINNYWRAP_ADDRESS_ELEMENT_ID = 'text2';
M.Cu3.ENVELOPE_FRONT_RAP_ELEMENT_IDS = ['text11'];
M.Cu3.ENVELOPE_FRONT_RAP_ELEMENT_ID = 'text11';
M.Cu3.ENVELOPE_RCP_SINGLE_ELEMENT_ID = 'text300';
M.Cu3.ENVELOPE_RCP_NON_VISIBLE_ELEMENT_ID = 'text301';
M.Cu3.ENVELOPE_RCP_ELEMENT_IDS = ['text300', 'text301'];
M.Cu3.ENVELOPE_STAMP_ELEMENT_ID = 'postagestampoption';
// Stamp textlines start at 400.
M.Cu3.ENVELOPE_STAMP_ELEMENT_RANGE_START = 400;

// Currently used by AIO but extendable to other products that have
// 2 sets of RAP text boxes
M.Cu3.ALL_BACK_RAP_ELEMENT_IDS = ['text8', 'text9', 'text302', 'text303'];

// RCP_TODO: Remove
M.Cu3.ENVELOPE_RCP_ELEMENT_ID = 'text200';

M.Cu3.RCP_CONSTANT_PRICE = 0;

/*
 * Inject SKU's for the entire suite.
 * Example: Explode MIN-555-INV into DIR, TYC, REC, RSV.
 */
var _injectSuiteAccessories = function(sku_list) {
  _.each(sku_list, function(sku) {
    _.each(['DIR','TYC','REC','RSV'], function(kind) {
      sku_list.push(sku.substr(0,8) + kind);
    });
  });
}
_injectSuiteAccessories(SKUS_TO_SVG);

// constants for booklette template option lists
M.Cu3.BOOKLETTE_LEFT_TEMPLATE_OPTION_LIST = 0;
M.Cu3.BOOKLETTE_RIGHT_TEMPLATE_OPTION_LIST = 1;

var PGHD_DIMENSIONS_TO_SCALES = {
  'HDSQ18': 0.30,
  'HDSQ20':0.25,
  'HDSQ24': 0.20,
  'HDSQ40': 0.15,
  'HD21x20': 0.25,
  'default': 0.15,
}

return {
  'DEV_NUM': DEV_NUM,
  'PREVIEW_TO_CU3_BACKER_SIZE_RATIO': PREVIEW_TO_CU3_BACKER_SIZE_RATIO,
  'Format': Format,
  'DEFAULT_MAP_DATA': DEFAULT_MAP_DATA,
  'Tier': Tier,
  'TierToStampOption': TierToStampOption,
  'FLAT_FORMAT': FLAT_FORMAT,
  'FOLDED_BLANK_FORMAT': FOLDED_BLANK_FORMAT,
  'FOLDED_YEARLINE_FORMAT': FOLDED_YEARLINE_FORMAT,
  'FOLDED_LETTER_FORMAT': FOLDED_LETTER_FORMAT,
  'FOLDED_MESSAGE_FORMAT': FOLDED_MESSAGE_FORMAT,
  'CALENDAR': CALENDAR,
  'LINED_NOTEBOOK_FORMAT': LINED_NOTEBOOK_FORMAT,
  'GRAPH_NOTEBOOK_FORMAT': GRAPH_NOTEBOOK_FORMAT,
  'BOOKLETTE_A_FORMAT': BOOKLETTE_A_FORMAT,
  'BOOKLETTE_B_FORMAT': BOOKLETTE_B_FORMAT,
  'BOOKLETTE_FORMAT': BOOKLETTE_FORMAT,
  'DIGITAL_INVITATION_FORMAT': DIGITAL_INVITATION_FORMAT,
  'FORMAT_TIER_MAP': FORMAT_TIER_MAP,
  'FORMAT_TO_CSS_CLASS_MAP': FORMAT_TO_CSS_CLASS_MAP,
  'SIGNATURE': SIGNATURE,
  'RECYCLED_PAPER': RECYCLED_PAPER,
  'PEARLESCENT': PEARLESCENT,
  'STRATHMORE': STRATHMORE,
  'CALENDAR_PAPER': CALENDAR_PAPER,
  'PREMIUM_UNCOATED': PREMIUM_UNCOATED,
  'TRIPLE_THICK': TRIPLE_THICK,
  'PARTY': PARTY,
  'MUSEUM_BOARD': MUSEUM_BOARD,
  'MAGNET': MAGNET,
  'SOMERSET_500': SOMERSET_500,
  'COVENTRY_320': COVENTRY_320,
  'POLY': POLY,
  'CANVAS': CANVAS,
  'DOUBLE_THICK': DOUBLE_THICK,
  'DELUXE_ART': DELUXE_ART,
  'SIGNATURE_80': SIGNATURE_80,
  'UNCOATED_STICKER': UNCOATED_STICKER,
  'WATERPROOF_LABEL': WATERPROOF_LABEL,
  'SMOOTH_SIGNATURE': SMOOTH_SIGNATURE,
  'RECYCLED_SMOOTH_SIGNATURE': RECYCLED_SMOOTH_SIGNATURE,
  'RECYCLED_PAPERS': RECYCLED_PAPERS,
  'PREMIUM_MATTE_ADHESIVE_FABRIC': PREMIUM_MATTE_ADHESIVE_FABRIC,
  'THICK_PAPER_KINDS': THICK_PAPER_KINDS,
  'TRIPLE_THICK_PAPER_KINDS': TRIPLE_THICK_PAPER_KINDS,
  'PAPER_OPTION_LABELS': PAPER_OPTION_LABELS,
  'ENABLE_ROTATED_TEXT': ENABLE_ROTATED_TEXT,
  'ENABLE_MOVEABLE_TEXT': ENABLE_MOVEABLE_TEXT,
  'ENABLE_MOVEABLE_IMAGE': ENABLE_MOVEABLE_IMAGE,
  'ENABLE_BACKER_ALT_COLORS': ENABLE_BACKER_ALT_COLORS,
  'ENABLE_SKINNYWRAP_COLORS': ENABLE_SKINNYWRAP_COLORS,
  'ENABLE_SKINNYWRAP_GREETINGS': ENABLE_SKINNYWRAP_GREETINGS,
  'ENABLE_CUSTOM_COLORS': ENABLE_CUSTOM_COLORS,
  'ENABLE_DRAG_DROP_PHOTO_UPLOAD': ENABLE_DRAG_DROP_PHOTO_UPLOAD,
  'ENABLE_SCENE7_OVERSET': ENABLE_SCENE7_OVERSET,
  'ENABLE_ROTATE_IMAGE': ENABLE_ROTATE_IMAGE,
  'ENABLE_PHOTO_DRAG_AND_DROP': ENABLE_PHOTO_DRAG_AND_DROP,
  'SKIP_REPLICA': SKIP_REPLICA,
  'IMAGE_OVERLAY_DRAG_CONTAINTMENT': IMAGE_OVERLAY_DRAG_CONTAINTMENT,
  'COLORWAY_CHANGED_EVENT': COLORWAY_CHANGED_EVENT,
  'FIRST_RENDER_EVENT': FIRST_RENDER_EVENT,
  'GAQ_CATEGORY': GAQ_CATEGORY,
  'MOUSEOVER_COLOR': MOUSEOVER_COLOR,
  'DEFAULT_COLOR': DEFAULT_COLOR,
  'MINTED_CDN': MINTED_CDN,
  'AMAZON_S3_ENDPOINT': AMAZON_S3_ENDPOINT,
  'THUMBNAIL_INDEX_COLORWAY': THUMBNAIL_INDEX_COLORWAY,
  'THUMBNAIL_TYPE_COLORWAY': THUMBNAIL_TYPE_COLORWAY,
  'THUMBNAIL_INDEX_BACKER': THUMBNAIL_INDEX_BACKER,
  'THUMBNAIL_TYPE_BACKER': THUMBNAIL_TYPE_BACKER,
  'THUMBNAIL_INDEX_VIEWCODE': THUMBNAIL_INDEX_VIEWCODE,
  'LARGE_THUMBNAIL_TYPE_COLORWAY': LARGE_THUMBNAIL_TYPE_COLORWAY,
  'DEFAULT_COLORWAY_CODE': DEFAULT_COLORWAY_CODE,
  'LARGE_PHOTO_CODE': LARGE_PHOTO_CODE,
  'ID_UNITPRICE': ID_UNITPRICE,
  'ID_TOTALPRICE': ID_TOTALPRICE,
  'PHOTO_GREY_MASK_S3KEY': PHOTO_GREY_MASK_S3KEY,
  'PHOTO_WHITE_MASK_S3KEY': PHOTO_WHITE_MASK_S3KEY,
  'TEMPLATE_MAX_WIDTH': TEMPLATE_MAX_WIDTH,
  'TEMPLATE_BUSINESS_MAX_WIDTH': TEMPLATE_BUSINESS_MAX_WIDTH,
  'TEMPLATE_INSIDE_MAX_WIDTH': TEMPLATE_INSIDE_MAX_WIDTH,
  'IMAGE_DRAGBOX_SIZE': IMAGE_DRAGBOX_SIZE,
  'INSIDE_TEMPLATE_HEIGHT_CONSTRAINT': INSIDE_TEMPLATE_HEIGHT_CONSTRAINT,
  'TEMPLATE_ENVELOPE_CONTAINER_SIZE': TEMPLATE_ENVELOPE_CONTAINER_SIZE,
  'SKINNYWRAP_IMAGEBOX_SIZE': SKINNYWRAP_IMAGEBOX_SIZE,
  'DEFAULT_SWATCH_SIZE': DEFAULT_SWATCH_SIZE,
  'MAX_SWATCH_SIZE': MAX_SWATCH_SIZE,
  'CALENDAR_MONTH_IMG_GROUP_KEY': CALENDAR_MONTH_IMG_GROUP_KEY,
  'CALENDAR_YEAR_IMG_GROUP_KEY': CALENDAR_YEAR_IMG_GROUP_KEY,
  'SWFUPLOAD_BUTTON_SIZE': SWFUPLOAD_BUTTON_SIZE,
  'PHOTOTRAY_ICON_WIDTH': PHOTOTRAY_ICON_WIDTH,
  'VALID_UPLOAD_TYPES': VALID_UPLOAD_TYPES,
  'SCREEN_DPI': SCREEN_DPI,
  'WARNING_DPI': WARNING_DPI,
  'LOWEST_DPI': LOWEST_DPI,
  'OUTZOOM_MAX': OUTZOOM_MAX,
  'MARGIN_OF_ERROR': MARGIN_OF_ERROR,
  'ZOOM_AMOUNT': ZOOM_AMOUNT,
  'MAX_ZOOMS_BEFORE_PIXELATION': MAX_ZOOMS_BEFORE_PIXELATION,
  'MINIMUM_DELAY_FOR_AJAX_SEND': MINIMUM_DELAY_FOR_AJAX_SEND,
  'BLUR_FIX_WIDTH_MAP': BLUR_FIX_WIDTH_MAP,
  'LINER_TYPE_SQ5_GOLD': LINER_TYPE_SQ5_GOLD,
  'LINER_TYPE_SQ5_SILV': LINER_TYPE_SQ5_SILV,
  'LINER_TYPE_SQ5_GLIT': LINER_TYPE_SQ5_GLIT,
  'LINER_TYPE_SQ6_GOLD': LINER_TYPE_SQ6_GOLD,
  'LINER_TYPE_SQ6_SILV': LINER_TYPE_SQ6_SILV,
  'LINER_TYPE_SQ6_GLIT': LINER_TYPE_SQ6_GLIT,
  'LINER_TYPE_A7_GOLD': LINER_TYPE_A7_GOLD,
  'LINER_TYPE_A7_SILV': LINER_TYPE_A7_SILV,
  'LINER_TYPE_A7_GLIT': LINER_TYPE_A7_GLIT,
  'PROOF_SERVICE_EXPRESS': PROOF_SERVICE_EXPRESS,
  'PROOF_SERVICE_FULL': PROOF_SERVICE_FULL,
  'ITEM_TYPE_MAIN': ITEM_TYPE_MAIN,
  'ITEM_TYPE_RAP': ITEM_TYPE_RAP,
  'ITEM_TYPE_SKINNYWRAP': ITEM_TYPE_SKINNYWRAP,
  'TYPE_OPTIONS': TYPE_OPTIONS,
  'TYPE_FRONT': TYPE_FRONT,
  'TYPE_BACK': TYPE_BACK,
  'TYPE_INSIDE': TYPE_INSIDE,
  'TYPE_BOOKLETTE_INSIDE': TYPE_BOOKLETTE_INSIDE,
  'TYPE_ENVELOPE': TYPE_ENVELOPE,
  'TYPE_SKINNYWRAP': TYPE_SKINNYWRAP,
  'TYPE_NAMES': TYPE_NAMES,
  'TYPE_STAMPS': TYPE_STAMPS,
  'TYPE_ADDRESSES': TYPE_ADDRESSES,
  'TYPE_DI_FRONT': TYPE_DI_FRONT,
  'TYPE_DI_BACKGROUND': TYPE_DI_BACKGROUND,
  'TYPE_DI_DETAILS': TYPE_DI_DETAILS,
  'TYPE_DI_DELIVERY': TYPE_DI_DELIVERY,
  'DI_BACKGROUND_TAB' : DI_BACKGROUND_TAB,
  'DI_DETAILS_TAB' : DI_DETAILS_TAB,
  'TYPE_PREVIEW': TYPE_PREVIEW,
  'FRAME_IDS': FRAME_IDS,
  'TEMPLATE_DATA_TYPE_FRONT': TEMPLATE_DATA_TYPE_FRONT,
  'TEMPLATE_DATA_TYPE_BACKER': TEMPLATE_DATA_TYPE_BACKER,
  'TEMPLATE_DATA_TYPE_ENVELOPE': TEMPLATE_DATA_TYPE_ENVELOPE,
  'FORMAT_YEARLINE': FORMAT_YEARLINE,
  'VALID_COLOR_TAB_TYPES': VALID_COLOR_TAB_TYPES,
  'CROP_SAVE': CROP_SAVE,
  'CROP_LOAD': CROP_LOAD,
  'CROP_NORMAL': CROP_NORMAL,
  'TEXTBOX_ADJUSTMENT': TEXTBOX_ADJUSTMENT,
  'BLEED_LENGTH': BLEED_LENGTH,
  'BLEED_MASK': BLEED_MASK,
  'EMBED_BLEED': EMBED_BLEED,
  'CUSTOM_COLORS_INSTRUCTIONS_DEFAULT_TEXT': CUSTOM_COLORS_INSTRUCTIONS_DEFAULT_TEXT,
  'CUSTOM_COLORS_FIRST_LAUNCH_DEFAULT_TEXT': CUSTOM_COLORS_FIRST_LAUNCH_DEFAULT_TEXT,
  'CUSTOM_COLORS_CUSTOMIZATION_DEFAULT_TEXT': CUSTOM_COLORS_CUSTOMIZATION_DEFAULT_TEXT,
  'DESIGN_REQUESTS_DEFAULT_TEXT': DESIGN_REQUESTS_DEFAULT_TEXT,
  'DESIGN_REQUESTS_DEFAULT_TEXT_NO_PROOF': DESIGN_REQUESTS_DEFAULT_TEXT_NO_PROOF,
  'STATIC_ELEMENTS_DEFAULT_TEXT': STATIC_ELEMENTS_DEFAULT_TEXT,
  'CARDSIZES': CARDSIZES,
  'DIM_TO_CARDSIZES': DIM_TO_CARDSIZES,
  'CALENDAR_STANDARD_DIMENSIONS': CALENDAR_STANDARD_DIMENSIONS,
  'CALENDAR_GRAND_DIMENSIONS': CALENDAR_GRAND_DIMENSIONS,
  'CALENDAR_CELLS': CALENDAR_CELLS,
  'CALENDAR_TEXT_CELLS_IDS_MAX': CALENDAR_TEXT_CELLS_IDS_MAX,
  'CALENDAR_TEXT_CELLS_IDS_MIN': CALENDAR_TEXT_CELLS_IDS_MIN,
  'FORM_FACTOR_LANDSCAPE': FORM_FACTOR_LANDSCAPE,
  'FORM_FACTOR_PORTRAIT': FORM_FACTOR_PORTRAIT,
  'FORM_FACTOR_SQUARE': FORM_FACTOR_SQUARE,
  'ORIENTATION_LETTERS': ORIENTATION_LETTERS,
  'SKINNYWRAP_RENDER_SCALE': SKINNYWRAP_RENDER_SCALE,
  'MAX_ODD_FONT_SIZE': MAX_ODD_FONT_SIZE,
  'MIN_DESIGN_ELEMENT_SIZE': MIN_DESIGN_ELEMENT_SIZE,
  'DUPLICATE_FONT_COLOR_THRESHOLD': DUPLICATE_FONT_COLOR_THRESHOLD,
  'NUDGE_AMOUNT': NUDGE_AMOUNT,
  'NUDGE_UP': NUDGE_UP,
  'NUDGE_RIGHT': NUDGE_RIGHT,
  'NUDGE_DOWN': NUDGE_DOWN,
  'NUDGE_LEFT': NUDGE_LEFT,
  'PRICING_FREE_BIZ_CARDS': PRICING_FREE_BIZ_CARDS,
  'NO_LINER': NO_LINER,
  'LOW_ATV_NO_PROOF': LOW_ATV_NO_PROOF,
  'ART_CU3_W_PROOF': ART_CU3_W_PROOF,
  'ART_CU3_NO_PROOF': ART_CU3_NO_PROOF,
  'ART_WEB_TO_PRINT': ART_WEB_TO_PRINT,
  'ALTERNATE_BACKER_PRODUCT_TYPES': ALTERNATE_BACKER_PRODUCT_TYPES,
  'ALTERNATE_INTERIOR_PRODUCT_TYPES': ALTERNATE_INTERIOR_PRODUCT_TYPES,
  'NO_INSIDE_TAB': NO_INSIDE_TAB,
  'NO_BACKER': NO_BACKER,
  'NO_BACK_TAB': NO_BACK_TAB,
  'ENABLE_ALTERNATE_GREETINGS': ENABLE_ALTERNATE_GREETINGS,
  'GIFT_TAG_SQUARE': GIFT_TAG_SQUARE,
  'GIFT_TAG_LANDSCAPE': GIFT_TAG_LANDSCAPE,
  'GIFT_TAG_PORTRAIT': GIFT_TAG_PORTRAIT,
  'GIFT_TAG_SQUARE_BACKER': GIFT_TAG_SQUARE_BACKER,
  'GIFT_TAG_LANDSCAPE_BACKER': GIFT_TAG_LANDSCAPE_BACKER,
  'GIFT_TAG_PORTRAIT_BACKER': GIFT_TAG_PORTRAIT_BACKER,
  'POSTCARD_LANDSCAPE': POSTCARD_LANDSCAPE,
  'POSTCARD_PORTRAIT': POSTCARD_PORTRAIT,
  'CALENDAR_STANDARD_FXG': CALENDAR_STANDARD_FXG,
  'CALENDAR_GRAND_FXG': CALENDAR_GRAND_FXG,
  'SKUS_TO_SVG': SKUS_TO_SVG,
  'EnvelopeRapOption': EnvelopeRapOption,
  'EnvelopeRcpOption': EnvelopeRcpOption,
  'RCP_RECIPIENT_TYPE': RCP_RECIPIENT_TYPE,
  'EnvelopeOptionType': EnvelopeOptionType,
  'StampOption': StampOption,
  'BackerType': BackerType,
  'SHARED_MAP_TYPE': SHARED_MAP_TYPE,
  'Scene7ParamKeyPrefix': Scene7ParamKeyPrefix,
  'Scene7ParamKey': Scene7ParamKey,
  '_injectSuiteAccessories': _injectSuiteAccessories,
  'STAMP_FXG': STAMP_FXG,
  'STAMP_TIER_TO_FXG_MAP': STAMP_TIER_TO_FXG_MAP,
  'TOOLTIP_LOCAL_STORE_KEY': TOOLTIP_LOCAL_STORE_KEY,
  'REGEX_SHARED_TEXT_ID': REGEX_SHARED_TEXT_ID,
  'BELLY_BAND_EMBED': BELLY_BAND_EMBED,
  'BELLY_BAND_EMBED_PREVIEW': BELLY_BAND_EMBED_PREVIEW,
  'ONE_PAGE_CALENDAR_ZOOM_COEFFICIENT': ONE_PAGE_CALENDAR_ZOOM_COEFFICIENT,
  'ONE_PAGE_CALENDAR_USER_ZOOM_COEFFICIENT': ONE_PAGE_CALENDAR_USER_ZOOM_COEFFICIENT,
  'ONE_PAGE_CALENDAR_EMBED': ONE_PAGE_CALENDAR_EMBED,
  'USER_USED_ADDRESS_BOOK_DISCOUNT_ENDPOINT': '/api/user/attributes/used_addressbook_incentive_discount',
  'ADD_ADDRESS_BOOK_INCENTIVE_TO_CART_ENDPOINT': '/addresses-incentive/add-to-cart',
  'GET_USER_FRIEND_ADDRESSES_ENDPOINT': '/backbone/friend-addresses',
  'PGHD_DIMENSIONS_TO_SCALES': PGHD_DIMENSIONS_TO_SCALES,
  'CARD_INTERIOR_TEMPLATE_TYPES': CARD_INTERIOR_TEMPLATE_TYPES,
  'A2_POSTCARD': A2_POSTCARD,
};

});
